export const Images = {
    arabic1_hd: require('./Assets/Images/Arabic/Arabic_HD-1.jpg'),
    arabic2_hd: require('./Assets/Images/Arabic/Arabic_HD-2.jpeg'),
    arabic3_hd: require('./Assets/Images/Arabic/Arabic_HD-3.jpeg'),
    arabic4_hd: require('./Assets/Images/Arabic/Arabic_HD-4.jpg'),
    arabic5_hd: require('./Assets/Images/Arabic/Arabic_HD-5.jpg'),
    arabic6_hd: require('./Assets/Images/Arabic/Arabic_HD-6.jpeg'),
    arabic8_hd: require('./Assets/Images/Arabic/Arabic_HD-8.jpeg'),
    arabic10_hd: require('./Assets/Images/Arabic/Arabic_HD-10.pdf'),
    arabic11_hd: require('./Assets/Images/Arabic/Arabic_HD-11.pdf'),
    arabic12_hd: require('./Assets/Images/Arabic/Arabic_HD-12.jpg'),
    arabic13_hd: require('./Assets/Images/Arabic/Arabic_HD-13.pdf'),
    arabic14_hd: require('./Assets/Images/Arabic/Arabic_HD-14.pdf'),
    arabic15_hd: require('./Assets/Images/Arabic/Arabic_HD-15.pdf'),
    arabic16_hd: require('./Assets/Images/Arabic/Arabic_HD-16.pdf'),
    arabic17_hd: require('./Assets/Images/Arabic/Arabic_HD-17.png'),
    arabic18_hd: require('./Assets/Images/Arabic/Arabic_HD-18.pdf'),
    arabic19_hd: require('./Assets/Images/Arabic/Arabic_HD-19.pdf'),
    arabic20_hd: require('./Assets/Images/Arabic/Arabic_HD-20.pdf'),
    arabic21_hd: require('./Assets/Images/Arabic/Arabic_HD-21.pdf'),
    arabic22_hd: require('./Assets/Images/Arabic/Arabic_HD-22.pdf'),
    arabic23_hd: require('./Assets/Images/Arabic/Arabic_HD-23.pdf'),
    arabic24_hd: require('./Assets/Images/Arabic/Arabic_HD-24.pdf'),
    arabic25_hd: require('./Assets/Images/Arabic/Arabic_HD-25.pdf'),
    arabic26_hd: require('./Assets/Images/Arabic/Arabic_HD-26.pdf'),
    arabic27_hd: require('./Assets/Images/Arabic/Arabic_HD-27.pdf'),
    arabic28_hd: require('./Assets/Images/Arabic/Arabic_HD-28.pdf'),
    arabic29_hd: require('./Assets/Images/Arabic/Arabic_HD-29.pdf'),
    arabic30_hd: require('./Assets/Images/Arabic/Arabic_HD-30.pdf'),
    arabic31_hd: require('./Assets/Images/Arabic/Arabic_HD-31.pdf'),
    arabic32_hd: require('./Assets/Images/Arabic/Arabic_HD-32.pdf'),
    arabic33_hd: require('./Assets/Images/Arabic/Arabic_HD-33.pdf'),
    arabic34_hd: require('./Assets/Images/Arabic/Arabic_HD-34.pdf'),
    arabic35_hd: require('./Assets/Images/Arabic/Arabic_HD-35.pdf'),
    arabic36_hd: require('./Assets/Images/Arabic/Arabic_HD-36.pdf'),
    arabic37_hd: require('./Assets/Images/Arabic/Arabic_HD-37.pdf'),
    arabic38_hd: require('./Assets/Images/Arabic/Arabic_HD-38.pdf'),
    arabic39_hd: require('./Assets/Images/Arabic/Arabic_HD-39.pdf'),
    arabic40_hd: require('./Assets/Images/Arabic/Arabic_HD-40.pdf'),
    arabic41_hd: require('./Assets/Images/Arabic/Arabic_HD-41.pdf'),
    arabic42_hd: require('./Assets/Images/Arabic/Arabic_HD-42.pdf'),
    arabic43_hd: require('./Assets/Images/Arabic/Arabic_HD-43.pdf'),
    arabic44_hd: require('./Assets/Images/Arabic/Arabic_HD-44.pdf'),
    arabic45_hd: require('./Assets/Images/Arabic/Arabic_HD-45.pdf'),
    arabic46_hd: require('./Assets/Images/Arabic/Arabic_HD-46.pdf'),
    arabic47_hd: require('./Assets/Images/Arabic/Arabic_HD-47.pdf'),
    arabic48_hd: require('./Assets/Images/Arabic/Arabic_HD-48.pdf'),
    arabic49_hd: require('./Assets/Images/Arabic/Arabic_HD-49.pdf'),
    arabic50_hd: require('./Assets/Images/Arabic/Arabic_HD-50.pdf'),
    arabic51_hd: require('./Assets/Images/Arabic/Arabic_HD-51.pdf'),
    arabic52_hd: require('./Assets/Images/Arabic/Arabic_HD-52.pdf'),
    arabic53_hd: require('./Assets/Images/Arabic/Arabic_HD-53.pdf'),
    arabic54_hd: require('./Assets/Images/Arabic/Arabic_HD-54.pdf'),
    arabic55_hd: require('./Assets/Images/Arabic/Arabic_HD-55.pdf'),
    arabic56_hd: require('./Assets/Images/Arabic/Arabic_HD-56.pdf'),
    arabic57_hd: require('./Assets/Images/Arabic/Arabic_HD-57.pdf'),
    arabic58_hd: require('./Assets/Images/Arabic/Arabic_HD-58.pdf'),
    arabic59_hd: require('./Assets/Images/Arabic/Arabic_HD-59.pdf'),
    arabic60_hd: require('./Assets/Images/Arabic/Arabic_HD-60.pdf'),
    arabic61_hd: require('./Assets/Images/Arabic/Arabic_HD-61.pdf'),
    arabic62_hd: require('./Assets/Images/Arabic/Arabic_HD-62.pdf'),
    arabic63_hd: require('./Assets/Images/Arabic/Arabic_HD-63.pdf'),
    arabic64_hd: require('./Assets/Images/Arabic/Arabic_HD-64.pdf'),
    arabic65_hd: require('./Assets/Images/Arabic/Arabic_HD-65.pdf'),
    arabic66_hd: require('./Assets/Images/Arabic/Arabic_HD-66.pdf'),
    arabic67_hd: require('./Assets/Images/Arabic/Arabic_HD-67.pdf'),
    arabic68_hd: require('./Assets/Images/Arabic/Arabic_HD-68.pdf'),

    arabic1_ld: require('./Assets/Images/Arabic/Arabic_LD-1.jpg'),
    arabic2_ld: require('./Assets/Images/Arabic/Arabic_LD-2.png'),
    arabic3_ld: require('./Assets/Images/Arabic/Arabic_LD-3.png'),
    arabic4_ld: require('./Assets/Images/Arabic/Arabic_LD-4.jpg'),
    arabic5_ld: require('./Assets/Images/Arabic/Arabic_LD-5.jpg'),
    arabic6_ld: require('./Assets/Images/Arabic/Arabic_LD-6.png'),
    arabic8_ld: require('./Assets/Images/Arabic/Arabic_LD-8.jpeg'),
    arabic10_ld: require('./Assets/Images/Arabic/Arabic_LD-10.png'),
    arabic11_ld: require('./Assets/Images/Arabic/Arabic_LD-11.png'),
    arabic12_ld: require('./Assets/Images/Arabic/Arabic_LD-12.jpg'),
    arabic13_ld: require('./Assets/Images/Arabic/Arabic_LD-13.png'),
    arabic14_ld: require('./Assets/Images/Arabic/Arabic_LD-14.png'),
    arabic15_ld: require('./Assets/Images/Arabic/Arabic_LD-15.png'),
    arabic16_ld: require('./Assets/Images/Arabic/Arabic_LD-16.png'),
    arabic17_ld: require('./Assets/Images/Arabic/Arabic_LD-17.png'),
    arabic18_ld: require('./Assets/Images/Arabic/Arabic_LD-18.png'),
    arabic19_ld: require('./Assets/Images/Arabic/Arabic_LD-19.png'),
    arabic20_ld: require('./Assets/Images/Arabic/Arabic_LD-20.png'),
    arabic21_ld: require('./Assets/Images/Arabic/Arabic_LD-21.png'),
    arabic22_ld: require('./Assets/Images/Arabic/Arabic_LD-22.png'),
    arabic23_ld: require('./Assets/Images/Arabic/Arabic_LD-23.png'),
    arabic24_ld: require('./Assets/Images/Arabic/Arabic_LD-24.png'),
    arabic25_ld: require('./Assets/Images/Arabic/Arabic_LD-25.jpeg'),
    arabic26_ld: require('./Assets/Images/Arabic/Arabic_LD-26.png'),
    arabic27_ld: require('./Assets/Images/Arabic/Arabic_LD-27.png'),
    arabic28_ld: require('./Assets/Images/Arabic/Arabic_LD-28.png'),
    arabic29_ld: require('./Assets/Images/Arabic/Arabic_LD-29.png'),
    arabic30_ld: require('./Assets/Images/Arabic/Arabic_LD-30.jpeg'),
    arabic31_ld: require('./Assets/Images/Arabic/Arabic_LD-31.png'),
    arabic32_ld: require('./Assets/Images/Arabic/Arabic_LD-32.jpg'),
    arabic33_ld: require('./Assets/Images/Arabic/Arabic_LD-33.jpg'),
    arabic34_ld: require('./Assets/Images/Arabic/Arabic_LD-34.jpg'),
    arabic35_ld: require('./Assets/Images/Arabic/Arabic_LD-35.jpg'),
    arabic36_ld: require('./Assets/Images/Arabic/Arabic_LD-36.jpg'),
    arabic37_ld: require('./Assets/Images/Arabic/Arabic_LD-37.jpg'),
    arabic38_ld: require('./Assets/Images/Arabic/Arabic_LD-38.jpg'),
    arabic39_ld: require('./Assets/Images/Arabic/Arabic_LD-39.jpg'),
    arabic40_ld: require('./Assets/Images/Arabic/Arabic_LD-40.jpg'),
    arabic41_ld: require('./Assets/Images/Arabic/Arabic_LD-41.jpg'),
    arabic42_ld: require('./Assets/Images/Arabic/Arabic_LD-42.jpg'),
    arabic43_ld: require('./Assets/Images/Arabic/Arabic_LD-43.jpg'),
    arabic44_ld: require('./Assets/Images/Arabic/Arabic_LD-44.jpg'),
    arabic45_ld: require('./Assets/Images/Arabic/Arabic_LD-45.jpeg'),
    arabic46_ld: require('./Assets/Images/Arabic/Arabic_LD-46.jpg'),
    arabic47_ld: require('./Assets/Images/Arabic/Arabic_LD-47.jpg'),
    arabic48_ld: require('./Assets/Images/Arabic/Arabic_LD-48.jpg'),
    arabic49_ld: require('./Assets/Images/Arabic/Arabic_LD-49.png'),
    arabic50_ld: require('./Assets/Images/Arabic/Arabic_LD-50.png'),
    arabic51_ld: require('./Assets/Images/Arabic/Arabic_LD-51.png'),
    arabic52_ld: require('./Assets/Images/Arabic/Arabic_LD-52.png'),
    arabic53_ld: require('./Assets/Images/Arabic/Arabic_LD-53.png'),
    arabic54_ld: require('./Assets/Images/Arabic/Arabic_LD-54.png'),
    arabic55_ld: require('./Assets/Images/Arabic/Arabic_LD-55.png'),
    arabic56_ld: require('./Assets/Images/Arabic/Arabic_LD-56.png'),
    arabic57_ld: require('./Assets/Images/Arabic/Arabic_LD-57.png'),
    arabic58_ld: require('./Assets/Images/Arabic/Arabic_LD-58.png'),
    arabic59_ld: require('./Assets/Images/Arabic/Arabic_LD-59.png'),
    arabic60_ld: require('./Assets/Images/Arabic/Arabic_LD-60.png'),
    arabic61_ld: require('./Assets/Images/Arabic/Arabic_LD-61.png'),
    arabic62_ld: require('./Assets/Images/Arabic/Arabic_LD-62.png'),
    arabic63_ld: require('./Assets/Images/Arabic/Arabic_LD-63.png'),
    arabic64_ld: require('./Assets/Images/Arabic/Arabic_LD-64.png'),
    arabic65_ld: require('./Assets/Images/Arabic/Arabic_LD-65.png'),
    arabic66_ld: require('./Assets/Images/Arabic/Arabic_LD-66.png'),
    arabic67_ld: require('./Assets/Images/Arabic/Arabic_LD-67.png'),
    arabic68_ld: require('./Assets/Images/Arabic/Arabic_LD-68.png'),


    bangali1_hd: require('./Assets/Images/Bangali/Bangali_HD-1.jpeg'),
    bangali2_hd: require('./Assets/Images/Bangali/Bangali_HD-2.jpeg'),
    bangali3_hd: require('./Assets/Images/Bangali/Bangali_HD-3.jpeg'),
    bangali4_hd: require('./Assets/Images/Bangali/Bangali_HD-4.jpg'),
    bangali5_hd: require('./Assets/Images/Bangali/Bangali_HD-5.jpg'),
    bangali6_hd: require('./Assets/Images/Bangali/Bangali_HD-6.jpeg'),
    bangali8_hd: require('./Assets/Images/Bangali/Bangali_HD-8.jpeg'),
    bangali10_hd: require('./Assets/Images/Bangali/Bangali_HD-10.pdf'),
    bangali11_hd: require('./Assets/Images/Bangali/Bangali_HD-11.pdf'),
    bangali12_hd: require('./Assets/Images/Bangali/Bangali_HD-12.jpg'),
    bangali13_hd: require('./Assets/Images/Bangali/Bangali_HD-13.pdf'),
    bangali14_hd: require('./Assets/Images/Bangali/Bangali_HD-14.pdf'),
    bangali15_hd: require('./Assets/Images/Bangali/Bangali_HD-15.pdf'),
    bangali16_hd: require('./Assets/Images/Bangali/Bangali_HD-16.pdf'),
    bangali17_hd: require('./Assets/Images/Bangali/Bangali_HD-17.pdf'),
    bangali18_hd: require('./Assets/Images/Bangali/Bangali_HD-18.pdf'),
    bangali19_hd: require('./Assets/Images/Bangali/Bangali_HD-19.pdf'),
    bangali20_hd: require('./Assets/Images/Bangali/Bangali_HD-20.pdf'),
    bangali22_hd: require('./Assets/Images/Bangali/Bangali_HD-22.pdf'),
    bangali23_hd: require('./Assets/Images/Bangali/Bangali_HD-23.pdf'),
    bangali24_hd: require('./Assets/Images/Bangali/Bangali_HD-24.pdf'),
    bangali25_hd: require('./Assets/Images/Bangali/Bangali_HD-25.pdf'),
    bangali26_hd: require('./Assets/Images/Bangali/Bangali_HD-26.pdf'),
    bangali27_hd: require('./Assets/Images/Bangali/Bangali_HD-27.pdf'),
    bangali28_hd: require('./Assets/Images/Bangali/Bangali_HD-28.pdf'),
    bangali29_hd: require('./Assets/Images/Bangali/Bangali_HD-29.pdf'),
    bangali30_hd: require('./Assets/Images/Bangali/Bangali_HD-30.pdf'),
    bangali31_hd: require('./Assets/Images/Bangali/Bangali_HD-31.pdf'),
    bangali32_hd: require('./Assets/Images/Bangali/Bangali_HD-32.pdf'),
    bangali33_hd: require('./Assets/Images/Bangali/Bangali_HD-33.pdf'),
    bangali34_hd: require('./Assets/Images/Bangali/Bangali_HD-34.pdf'),
    bangali35_hd: require('./Assets/Images/Bangali/Bangali_HD-35.pdf'),
    bangali36_hd: require('./Assets/Images/Bangali/Bangali_HD-36.pdf'),
    bangali37_hd: require('./Assets/Images/Bangali/Bangali_HD-37.pdf'),
    bangali38_hd: require('./Assets/Images/Bangali/Bangali_HD-38.pdf'),
    bangali39_hd: require('./Assets/Images/Bangali/Bangali_HD-39.pdf'),
    bangali40_hd: require('./Assets/Images/Bangali/Bangali_HD-40.pdf'),
    bangali41_hd: require('./Assets/Images/Bangali/Bangali_HD-41.pdf'),
    bangali42_hd: require('./Assets/Images/Bangali/Bangali_HD-42.pdf'),
    bangali43_hd: require('./Assets/Images/Bangali/Bangali_HD-43.pdf'),
    bangali44_hd: require('./Assets/Images/Bangali/Bangali_HD-44.pdf'),
    bangali45_hd: require('./Assets/Images/Bangali/Bangali_HD-45.pdf'),
    bangali46_hd: require('./Assets/Images/Bangali/Bangali_HD-46.pdf'),
    bangali47_hd: require('./Assets/Images/Bangali/Bangali_HD-47.pdf'),
    bangali48_hd: require('./Assets/Images/Bangali/Bangali_HD-48.pdf'),
    bangali49_hd: require('./Assets/Images/Bangali/Bangali_HD-49.pdf'),
    bangali50_hd: require('./Assets/Images/Bangali/Bangali_HD-50.pdf'),
    bangali51_hd: require('./Assets/Images/Bangali/Bangali_HD-51.pdf'),
    bangali52_hd: require('./Assets/Images/Bangali/Bangali_HD-52.pdf'),
    bangali53_hd: require('./Assets/Images/Bangali/Bangali_HD-53.pdf'),
    bangali54_hd: require('./Assets/Images/Bangali/Bangali_HD-54.pdf'),
    bangali55_hd: require('./Assets/Images/Bangali/Bangali_HD-55.pdf'),
    bangali56_hd: require('./Assets/Images/Bangali/Bangali_HD-56.pdf'),
    bangali57_hd: require('./Assets/Images/Bangali/Bangali_HD-57.pdf'),
    bangali58_hd: require('./Assets/Images/Bangali/Bangali_HD-58.pdf'),
    bangali59_hd: require('./Assets/Images/Bangali/Bangali_HD-59.pdf'),
    bangali60_hd: require('./Assets/Images/Bangali/Bangali_HD-60.pdf'),
    bangali61_hd: require('./Assets/Images/Bangali/Bangali_HD-61.pdf'),
    bangali62_hd: require('./Assets/Images/Bangali/Bangali_HD-62.pdf'),
    bangali63_hd: require('./Assets/Images/Bangali/Bangali_HD-63.pdf'),
    bangali64_hd: require('./Assets/Images/Bangali/Bangali_HD-64.pdf'),
    bangali65_hd: require('./Assets/Images/Bangali/Bangali_HD-65.pdf'),
    bangali66_hd: require('./Assets/Images/Bangali/Bangali_HD-66.pdf'),
    bangali67_hd: require('./Assets/Images/Bangali/Bangali_HD-67.pdf'),
    bangali68_hd: require('./Assets/Images/Bangali/Bangali_HD-68.pdf'),
    bangali69_hd: require('./Assets/Images/Bangali/Bangali_HD-69.pdf'),

    bangali1_ld: require('./Assets/Images/Bangali/Bangali_LD-1.jpg'),
    bangali2_ld: require('./Assets/Images/Bangali/Bangali_LD-2.jpg'),
    bangali3_ld: require('./Assets/Images/Bangali/Bangali_LD-3.jpg'),
    bangali4_ld: require('./Assets/Images/Bangali/Bangali_LD-4.jpg'),
    bangali5_ld: require('./Assets/Images/Bangali/Bangali_LD-5.jpg'),
    bangali6_ld: require('./Assets/Images/Bangali/Bangali_LD-6.jpg'),
    bangali8_ld: require('./Assets/Images/Bangali/Bangali_LD-8.jpeg'),
    bangali10_ld: require('./Assets/Images/Bangali/Bangali_LD-10.png'),
    bangali11_ld: require('./Assets/Images/Bangali/Bangali_LD-11.png'),
    bangali12_ld: require('./Assets/Images/Bangali/Bangali_LD-12.jpg'),
    bangali13_ld: require('./Assets/Images/Bangali/Bangali_LD-13.png'),
    bangali14_ld: require('./Assets/Images/Bangali/Bangali_LD-14.png'),
    bangali15_ld: require('./Assets/Images/Bangali/Bangali_LD-15.png'),
    bangali16_ld: require('./Assets/Images/Bangali/Bangali_LD-16.png'),
    bangali17_ld: require('./Assets/Images/Bangali/Bangali_LD-17.png'),
    bangali18_ld: require('./Assets/Images/Bangali/Bangali_LD-18.png'),
    bangali19_ld: require('./Assets/Images/Bangali/Bangali_LD-19.png'),
    bangali20_ld: require('./Assets/Images/Bangali/Bangali_LD-20.png'),
    bangali22_ld: require('./Assets/Images/Bangali/Bangali_LD-22.png'),
    bangali23_ld: require('./Assets/Images/Bangali/Bangali_LD-23.png'),
    bangali24_ld: require('./Assets/Images/Bangali/Bangali_LD-24.png'),
    bangali25_ld: require('./Assets/Images/Bangali/Bangali_LD-25.png'),
    bangali26_ld: require('./Assets/Images/Bangali/Bangali_LD-26.jpeg'),
    bangali27_ld: require('./Assets/Images/Bangali/Bangali_LD-27.png'),
    bangali28_ld: require('./Assets/Images/Bangali/Bangali_LD-28.png'),
    bangali29_ld: require('./Assets/Images/Bangali/Bangali_LD-29.png'),
    bangali30_ld: require('./Assets/Images/Bangali/Bangali_LD-30.jpeg'),
    bangali31_ld: require('./Assets/Images/Bangali/Bangali_LD-31.png'),
    bangali32_ld: require('./Assets/Images/Bangali/Bangali_LD-32.jpg'),
    bangali33_ld: require('./Assets/Images/Bangali/Bangali_LD-33.jpg'),
    bangali34_ld: require('./Assets/Images/Bangali/Bangali_LD-34.jpg'),
    bangali35_ld: require('./Assets/Images/Bangali/Bangali_LD-35.jpg'),
    bangali36_ld: require('./Assets/Images/Bangali/Bangali_LD-36.jpg'),
    bangali37_ld: require('./Assets/Images/Bangali/Bangali_LD-37.jpg'),
    bangali38_ld: require('./Assets/Images/Bangali/Bangali_LD-38.jpg'),
    bangali39_ld: require('./Assets/Images/Bangali/Bangali_LD-39.jpg'),
    bangali40_ld: require('./Assets/Images/Bangali/Bangali_LD-40.jpg'),
    bangali41_ld: require('./Assets/Images/Bangali/Bangali_LD-41.jpg'),
    bangali42_ld: require('./Assets/Images/Bangali/Bangali_LD-42.jpg'),
    bangali43_ld: require('./Assets/Images/Bangali/Bangali_LD-43.jpg'),
    bangali44_ld: require('./Assets/Images/Bangali/Bangali_LD-44.jpg'),
    bangali45_ld: require('./Assets/Images/Bangali/Bangali_LD-45.jpg'),
    bangali46_ld: require('./Assets/Images/Bangali/Bangali_LD-46.jpg'),
    bangali47_ld: require('./Assets/Images/Bangali/Bangali_LD-47.jpg'),
    bangali48_ld: require('./Assets/Images/Bangali/Bangali_LD-48.jpg'),
    bangali49_ld: require('./Assets/Images/Bangali/Bangali_LD-49.jpg'),
    bangali50_ld: require('./Assets/Images/Bangali/Bangali_LD-50.png'),
    bangali51_ld: require('./Assets/Images/Bangali/Bangali_LD-51.png'),
    bangali52_ld: require('./Assets/Images/Bangali/Bangali_LD-52.png'),
    bangali53_ld: require('./Assets/Images/Bangali/Bangali_LD-53.png'),
    bangali54_ld: require('./Assets/Images/Bangali/Bangali_LD-54.png'),
    bangali55_ld: require('./Assets/Images/Bangali/Bangali_LD-55.png'),
    bangali56_ld: require('./Assets/Images/Bangali/Bangali_LD-56.png'),
    bangali57_ld: require('./Assets/Images/Bangali/Bangali_LD-57.png'),
    bangali58_ld: require('./Assets/Images/Bangali/Bangali_LD-58.png'),
    bangali59_ld: require('./Assets/Images/Bangali/Bangali_LD-59.png'),
    bangali60_ld: require('./Assets/Images/Bangali/Bangali_LD-60.png'),
    bangali61_ld: require('./Assets/Images/Bangali/Bangali_LD-61.png'),
    bangali62_ld: require('./Assets/Images/Bangali/Bangali_LD-62.png'),
    bangali63_ld: require('./Assets/Images/Bangali/Bangali_LD-63.png'),
    bangali64_ld: require('./Assets/Images/Bangali/Bangali_LD-64.png'),
    bangali65_ld: require('./Assets/Images/Bangali/Bangali_LD-65.png'),
    bangali66_ld: require('./Assets/Images/Bangali/Bangali_LD-66.png'),
    bangali67_ld: require('./Assets/Images/Bangali/Bangali_LD-67.png'),
    bangali68_ld: require('./Assets/Images/Bangali/Bangali_LD-68.png'),
    bangali69_ld: require('./Assets/Images/Bangali/Bangali_LD-69.png'),


    chinese1_hd: require('./Assets/Images/Chinese/Chinese_HD-1.jpeg'),
    chinese2_hd: require('./Assets/Images/Chinese/Chinese_HD-2.jpeg'),
    chinese3_hd: require('./Assets/Images/Chinese/Chinese_HD-3.jpeg'),
    chinese4_hd: require('./Assets/Images/Chinese/Chinese_HD-4.jpg'),
    chinese5_hd: require('./Assets/Images/Chinese/Chinese_HD-5.jpg'),
    chinese6_hd: require('./Assets/Images/Chinese/Chinese_HD-6.jpg'),
    chinese_positive_emotions_1_hd: require('./Assets/Images/Chinese/3_Positive-Emotions-1-HD.jpg'),
    chinese_positive_emotions_2_hd: require('./Assets/Images/Chinese/3_Positive-Emotions-2-HD.jpg'),
    chinese8_hd: require('./Assets/Images/Chinese/Chinese_HD-8.jpeg'),
    chinese10_hd: require('./Assets/Images/Chinese/Chinese_HD-10.pdf'),
    chinese11_hd: require('./Assets/Images/Chinese/Chinese_HD-11.pdf'),
    chinese12_hd: require('./Assets/Images/Chinese/Chinese_HD-12.jpg'),
    chinese13_hd: require('./Assets/Images/Chinese/Chinese_HD-13.pdf'),
    chinese14_hd: require('./Assets/Images/Chinese/Chinese_HD-14.pdf'),
    chinese15_hd: require('./Assets/Images/Chinese/Chinese_HD-15.pdf'),
    chinese16_hd: require('./Assets/Images/Chinese/Chinese_HD-16.pdf'),
    chinese17_hd: require('./Assets/Images/Chinese/Chinese_HD-17.pdf'),
    chinese18_hd: require('./Assets/Images/Chinese/Chinese_HD-18.pdf'),
    chinese19_hd: require('./Assets/Images/Chinese/Chinese_HD-19.pdf'),
    chinese20_hd: require('./Assets/Images/Chinese/Chinese_HD-20.pdf'),
    chinese21_hd: require('./Assets/Images/Chinese/Chinese_HD-21.pdf'),
    chinese22_hd: require('./Assets/Images/Chinese/Chinese_HD-22.pdf'),
    chinese23_hd: require('./Assets/Images/Chinese/Chinese_HD-23.pdf'),
    chinese24_hd: require('./Assets/Images/Chinese/Chinese_HD-24.pdf'),
    chinese25_hd: require('./Assets/Images/Chinese/Chinese_HD-25.pdf'),
    chinese26_hd: require('./Assets/Images/Chinese/Chinese_HD-26.pdf'),
    chinese27_hd: require('./Assets/Images/Chinese/Chinese_HD-27.pdf'),
    chinese28_hd: require('./Assets/Images/Chinese/Chinese_HD-28.pdf'),
    chinese29_hd: require('./Assets/Images/Chinese/Chinese_HD-29.pdf'),
    chinese30_hd: require('./Assets/Images/Chinese/Chinese_HD-30.pdf'),
    chinese31_hd: require('./Assets/Images/Chinese/Chinese_HD-31.pdf'),
    chinese32_hd: require('./Assets/Images/Chinese/Chinese_HD-32.pdf'),
    chinese33_hd: require('./Assets/Images/Chinese/Chinese_HD-33.pdf'),
    chinese34_hd: require('./Assets/Images/Chinese/Chinese_HD-34.pdf'),
    chinese35_hd: require('./Assets/Images/Chinese/Chinese_HD-35.pdf'),
    chinese36_hd: require('./Assets/Images/Chinese/Chinese_HD-36.pdf'),
    chinese37_hd: require('./Assets/Images/Chinese/Chinese_HD-37.pdf'),
    chinese38_hd: require('./Assets/Images/Chinese/Chinese_HD-38.pdf'),
    chinese39_hd: require('./Assets/Images/Chinese/Chinese_HD-39.pdf'),
    chinese40_hd: require('./Assets/Images/Chinese/Chinese_HD-40.pdf'),
    chinese41_hd: require('./Assets/Images/Chinese/Chinese_HD-41.pdf'),
    chinese42_hd: require('./Assets/Images/Chinese/Chinese_HD-42.pdf'),
    chinese43_hd: require('./Assets/Images/Chinese/Chinese_HD-43.pdf'),
    chinese44_hd: require('./Assets/Images/Chinese/Chinese_HD-44.pdf'),
    chinese45_hd: require('./Assets/Images/Chinese/Chinese_HD-45.pdf'),
    chinese46_hd: require('./Assets/Images/Chinese/Chinese_HD-46.pdf'),
    chinese47_hd: require('./Assets/Images/Chinese/Chinese_HD-47.pdf'),
    chinese48_hd: require('./Assets/Images/Chinese/Chinese_HD-48.pdf'),
    chinese49_hd: require('./Assets/Images/Chinese/Chinese_HD-49.pdf'),
    chinese50_hd: require('./Assets/Images/Chinese/Chinese_HD-50.pdf'),
    chinese51_hd: require('./Assets/Images/Chinese/Chinese_HD-51.pdf'),
    chinese52_hd: require('./Assets/Images/Chinese/Chinese_HD-52.pdf'),
    chinese53_hd: require('./Assets/Images/Chinese/Chinese_HD-53.pdf'),
    chinese54_hd: require('./Assets/Images/Chinese/Chinese_HD-54.pdf'),
    chinese55_hd: require('./Assets/Images/Chinese/Chinese_HD-55.pdf'),
    chinese56_hd: require('./Assets/Images/Chinese/Chinese_HD-56.pdf'),
    chinese57_hd: require('./Assets/Images/Chinese/Chinese_HD-57.pdf'),
    chinese58_hd: require('./Assets/Images/Chinese/Chinese_HD-58.pdf'),
    chinese59_hd: require('./Assets/Images/Chinese/Chinese_HD-59.pdf'),
    chinese60_hd: require('./Assets/Images/Chinese/Chinese_HD-60.pdf'),
    chinese61_hd: require('./Assets/Images/Chinese/Chinese_HD-61.pdf'),
    chinese62_hd: require('./Assets/Images/Chinese/Chinese_HD-62.pdf'),
    chinese63_hd: require('./Assets/Images/Chinese/Chinese_HD-63.pdf'),
    chinese64_hd: require('./Assets/Images/Chinese/Chinese_HD-64.pdf'),
    chinese65_hd: require('./Assets/Images/Chinese/Chinese_HD-65.pdf'),
    chinese66_hd: require('./Assets/Images/Chinese/Chinese_HD-66.pdf'),
    chinese67_hd: require('./Assets/Images/Chinese/Chinese_HD-67.pdf'),
    chinese68_hd: require('./Assets/Images/Chinese/Chinese_HD-68.pdf'),

    chinese1_ld: require('./Assets/Images/Chinese/Chinese_LD-1.jpg'),
    chinese2_ld: require('./Assets/Images/Chinese/Chinese_LD-2.jpg'),
    chinese3_ld: require('./Assets/Images/Chinese/Chinese_LD-3.jpg'),
    chinese4_ld: require('./Assets/Images/Chinese/Chinese_LD-4.jpg'),
    chinese5_ld: require('./Assets/Images/Chinese/Chinese_LD-5.jpg'),
    chinese6_ld: require('./Assets/Images/Chinese/Chinese_LD-6.jpg'),
    chinese_positive_emotions_1_ld: require('./Assets/Images/Chinese/3_Positive-Emotions-1-LD.jpg'),
    chinese_positive_emotions_2_ld: require('./Assets/Images/Chinese/3_Positive-Emotions-2-LD.jpg'),
    chinese8_ld: require('./Assets/Images/Chinese/Chinese_LD-8.jpeg'),
    chinese10_ld: require('./Assets/Images/Chinese/Chinese_LD-10.png'),
    chinese11_ld: require('./Assets/Images/Chinese/Chinese_LD-11.png'),
    chinese12_ld: require('./Assets/Images/Chinese/Chinese_LD-12.jpg'),
    chinese13_ld: require('./Assets/Images/Chinese/Chinese_LD-13.png'),
    chinese14_ld: require('./Assets/Images/Chinese/Chinese_LD-14.png'),
    chinese15_ld: require('./Assets/Images/Chinese/Chinese_LD-15.png'),
    chinese16_ld: require('./Assets/Images/Chinese/Chinese_LD-16.png'),
    chinese17_ld: require('./Assets/Images/Chinese/Chinese_LD-17.png'),
    chinese18_ld: require('./Assets/Images/Chinese/Chinese_LD-18.png'),
    chinese19_ld: require('./Assets/Images/Chinese/Chinese_LD-19.png'),
    chinese20_ld: require('./Assets/Images/Chinese/Chinese_LD-20.png'),
    chinese21_ld: require('./Assets/Images/Chinese/Chinese_LD-21.png'),
    chinese22_ld: require('./Assets/Images/Chinese/Chinese_LD-22.png'),
    chinese23_ld: require('./Assets/Images/Chinese/Chinese_LD-23.jpeg'),
    chinese24_ld: require('./Assets/Images/Chinese/Chinese_LD-24.png'),
    chinese25_ld: require('./Assets/Images/Chinese/Chinese_LD-25.png'),
    chinese26_ld: require('./Assets/Images/Chinese/Chinese_LD-26.png'),
    chinese27_ld: require('./Assets/Images/Chinese/Chinese_LD-27.png'),
    chinese28_ld: require('./Assets/Images/Chinese/Chinese_LD-28.png'),
    chinese29_ld: require('./Assets/Images/Chinese/Chinese_LD-29.png'),
    chinese30_ld: require('./Assets/Images/Chinese/Chinese_LD-30.png'),
    chinese31_ld: require('./Assets/Images/Chinese/Chinese_LD-31.png'),
    chinese32_ld: require('./Assets/Images/Chinese/Chinese_LD-32.jpg'),
    chinese33_ld: require('./Assets/Images/Chinese/Chinese_LD-33.jpg'),
    chinese34_ld: require('./Assets/Images/Chinese/Chinese_LD-34.jpg'),
    chinese35_ld: require('./Assets/Images/Chinese/Chinese_LD-35.jpg'),
    chinese36_ld: require('./Assets/Images/Chinese/Chinese_LD-36.jpg'),
    chinese37_ld: require('./Assets/Images/Chinese/Chinese_LD-37.jpg'),
    chinese38_ld: require('./Assets/Images/Chinese/Chinese_LD-38.jpg'),
    chinese39_ld: require('./Assets/Images/Chinese/Chinese_LD-39.jpg'),
    chinese40_ld: require('./Assets/Images/Chinese/Chinese_LD-40.jpg'),
    chinese41_ld: require('./Assets/Images/Chinese/Chinese_LD-41.jpg'),
    chinese42_ld: require('./Assets/Images/Chinese/Chinese_LD-42.jpg'),
    chinese43_ld: require('./Assets/Images/Chinese/Chinese_LD-43.jpg'),
    chinese44_ld: require('./Assets/Images/Chinese/Chinese_LD-44.jpg'),
    chinese45_ld: require('./Assets/Images/Chinese/Chinese_LD-45.jpg'),
    chinese46_ld: require('./Assets/Images/Chinese/Chinese_LD-46.jpg'),
    chinese47_ld: require('./Assets/Images/Chinese/Chinese_LD-47.jpg'),
    chinese48_ld: require('./Assets/Images/Chinese/Chinese_LD-48.jpg'),
    chinese49_ld: require('./Assets/Images/Chinese/Chinese_LD-49.png'),
    chinese50_ld: require('./Assets/Images/Chinese/Chinese_LD-50.png'),
    chinese51_ld: require('./Assets/Images/Chinese/Chinese_LD-51.png'),
    chinese52_ld: require('./Assets/Images/Chinese/Chinese_LD-52.png'),
    chinese53_ld: require('./Assets/Images/Chinese/Chinese_LD-53.png'),
    chinese54_ld: require('./Assets/Images/Chinese/Chinese_LD-54.png'),
    chinese55_ld: require('./Assets/Images/Chinese/Chinese_LD-55.png'),
    chinese56_ld: require('./Assets/Images/Chinese/Chinese_LD-56.png'),
    chinese57_ld: require('./Assets/Images/Chinese/Chinese_LD-57.png'),
    chinese58_ld: require('./Assets/Images/Chinese/Chinese_LD-58.png'),
    chinese59_ld: require('./Assets/Images/Chinese/Chinese_LD-59.png'),
    chinese60_ld: require('./Assets/Images/Chinese/Chinese_LD-60.png'),
    chinese61_ld: require('./Assets/Images/Chinese/Chinese_LD-61.png'),
    chinese62_ld: require('./Assets/Images/Chinese/Chinese_LD-62.png'),
    chinese63_ld: require('./Assets/Images/Chinese/Chinese_LD-63.png'),
    chinese64_ld: require('./Assets/Images/Chinese/Chinese_LD-64.png'),
    chinese65_ld: require('./Assets/Images/Chinese/Chinese_LD-65.png'),
    chinese66_ld: require('./Assets/Images/Chinese/Chinese_LD-66.png'),
    chinese67_ld: require('./Assets/Images/Chinese/Chinese_LD-67.png'),
    chinese68_ld: require('./Assets/Images/Chinese/Chinese_LD-68.png'),

    english1_hd: require('./Assets/Images/English/English_HD-1.png'),
    english2_hd: require('./Assets/Images/English/English_HD-2.jpeg'),
    english3_hd: require('./Assets/Images/English/English_HD-3.jpeg'),
    english4_hd: require('./Assets/Images/English/English_HD-4.jpg'),
    english5_hd: require('./Assets/Images/English/English_HD-5.jpg'),
    english6_hd: require('./Assets/Images/English/English_HD-6.jpg'),
    english8_hd: require('./Assets/Images/English/English_HD-8.jpeg'),
    english10_hd: require('./Assets/Images/English/English_HD-10.pdf'),
    english11_hd: require('./Assets/Images/English/English_HD-11.pdf'),
    english12_hd: require('./Assets/Images/English/English_HD-12.pdf'),
    english13_hd: require('./Assets/Images/English/English_HD-13.pdf'),
    english14_hd: require('./Assets/Images/English/English_HD-14.pdf'),
    english15_hd: require('./Assets/Images/English/English_HD-15.pdf'),
    english16_hd: require('./Assets/Images/English/English_HD-16.pdf'),
    english17_hd: require('./Assets/Images/English/English_HD-17.pdf'),
    english18_hd: require('./Assets/Images/English/English_HD-18.pdf'),
    english19_hd: require('./Assets/Images/English/English_HD-19.pdf'),
    english20_hd: require('./Assets/Images/English/English_HD-20.pdf'),
    english21_hd: require('./Assets/Images/English/English_HD-21.pdf'),
    english22_hd: require('./Assets/Images/English/English_HD-22.pdf'),
    english23_hd: require('./Assets/Images/English/English_HD-23.pdf'),
    english24_hd: require('./Assets/Images/English/English_HD-24.pdf'),
    english25_hd: require('./Assets/Images/English/English_HD-25.pdf'),
    english26_hd: require('./Assets/Images/English/English_HD-26.pdf'),
    english27_hd: require('./Assets/Images/English/English_HD-27.pdf'),
    english28_hd: require('./Assets/Images/English/English_HD-28.pdf'),
    english29_hd: require('./Assets/Images/English/English_HD-29.pdf'),
    english30_hd: require('./Assets/Images/English/English_HD-30.pdf'),
    english31_hd: require('./Assets/Images/English/English_HD-31.jpg'),
    english32_hd: require('./Assets/Images/English/English_HD-32.pdf'),
    english33_hd: require('./Assets/Images/English/English_HD-33.pdf'),
    english34_hd: require('./Assets/Images/English/English_HD-34.pdf'),
    english35_hd: require('./Assets/Images/English/English_HD-35.pdf'),
    english36_hd: require('./Assets/Images/English/English_HD-36.pdf'),
    english37_hd: require('./Assets/Images/English/English_HD-37.png'),
    english38_hd: require('./Assets/Images/English/English_HD-38.pdf'),
    english39_hd: require('./Assets/Images/English/English_HD-39.pdf'),
    english40_hd: require('./Assets/Images/English/English_HD-40.pdf'),
    english41_hd: require('./Assets/Images/English/English_HD-41.pdf'),
    english42_hd: require('./Assets/Images/English/English_HD-42.pdf'),
    english43_hd: require('./Assets/Images/English/English_HD-43.pdf'),
    english44_hd: require('./Assets/Images/English/English_HD-44.pdf'),
    english45_hd: require('./Assets/Images/English/English_HD-45.pdf'),
    english46_hd: require('./Assets/Images/English/English_HD-46.pdf'),
    english47_hd: require('./Assets/Images/English/English_HD-47.pdf'),
    english48_hd: require('./Assets/Images/English/English_HD-48.pdf'),
    english49_hd: require('./Assets/Images/English/English_HD-49.pdf'),
    english50_hd: require('./Assets/Images/English/English_HD-50.pdf'),
    english51_hd: require('./Assets/Images/English/English_HD-51.pdf'),
    english52_hd: require('./Assets/Images/English/English_HD-52.pdf'),
    english53_hd: require('./Assets/Images/English/English_HD-53.pdf'),
    english54_hd: require('./Assets/Images/English/English_HD-54.pdf'),
    english55_hd: require('./Assets/Images/English/English_HD-55.pdf'),
    english56_hd: require('./Assets/Images/English/English_HD-56.pdf'),
    english57_hd: require('./Assets/Images/English/English_HD-57.pdf'),
    english58_hd: require('./Assets/Images/English/English_HD-58.pdf'),
    english59_hd: require('./Assets/Images/English/English_HD-59.pdf'),
    english60_hd: require('./Assets/Images/English/English_HD-60.pdf'),
    english61_hd: require('./Assets/Images/English/English_HD-61.pdf'),
    english62_hd: require('./Assets/Images/English/English_HD-62.pdf'),
    english63_hd: require('./Assets/Images/English/English_HD-63.pdf'),
    english64_hd: require('./Assets/Images/English/English_HD-64.pdf'),
    english65_hd: require('./Assets/Images/English/English_HD-65.pdf'),
    english66_hd: require('./Assets/Images/English/English_HD-66.pdf'),
    english67_hd: require('./Assets/Images/English/English_HD-67.pdf'),
    english68_hd: require('./Assets/Images/English/English_HD-68.pdf'),
    english69_hd: require('./Assets/Images/English/English_HD-69.pdf'),
    english70_hd: require('./Assets/Images/English/English_HD-70.pdf'),
    english71_hd: require('./Assets/Images/English/English_HD-71.pdf'),
    english72_hd: require('./Assets/Images/English/English_HD-72.pdf'),
    english73_hd: require('./Assets/Images/English/English_HD-73.pdf'),
    english74_hd: require('./Assets/Images/English/English_HD-74.pdf'),
    english75_hd: require('./Assets/Images/English/English_HD-75.pdf'),
    english76_hd: require('./Assets/Images/English/English_HD-76.pdf'),
    english77_hd: require('./Assets/Images/English/English_HD-77.pdf'),
    english78_hd: require('./Assets/Images/English/English_HD-78.pdf'),
    english79_hd: require('./Assets/Images/English/English_HD-79.pdf'),
    english80_hd: require('./Assets/Images/English/English_HD-80.pdf'),

    english1_ld: require('./Assets/Images/English/English_LD-1.png'),
    english2_ld: require('./Assets/Images/English/English_LD-2.png'),
    english3_ld: require('./Assets/Images/English/English_LD-3.png'),
    english4_ld: require('./Assets/Images/English/English_LD-4.jpg'),
    english5_ld: require('./Assets/Images/English/English_LD-5.jpg'),
    english6_ld: require('./Assets/Images/English/English_LD-6.jpg'),
    english8_ld: require('./Assets/Images/English/English_LD-8.jpeg'),
    english10_ld: require('./Assets/Images/English/TBT.png'),
    english22_ld: require('./Assets/Images/English/English_LD-22.png'),
    english23_ld: require('./Assets/Images/English/English_LD-23.png'),
    english24_ld: require('./Assets/Images/English/English_LD-24.png'),
    english25_ld: require('./Assets/Images/English/English_LD-25.png'),
    english26_ld: require('./Assets/Images/English/English_LD-26.png'),
    english27_ld: require('./Assets/Images/English/English_LD-27.png'),
    english28_ld: require('./Assets/Images/English/English_LD-28.png'),
    english29_ld: require('./Assets/Images/English/English_LD-29.png'),
    english30_ld: require('./Assets/Images/English/English_LD-30.png'),
    english31_ld: require('./Assets/Images/English/English_LD-31.jpg'),
    english32_ld: require('./Assets/Images/English/English_LD-32.png'),
    english33_ld: require('./Assets/Images/English/English_LD-33.png'),
    english34_ld: require('./Assets/Images/English/English_LD-34.png'),
    english35_ld: require('./Assets/Images/English/English_LD-35.png'),
    english36_ld: require('./Assets/Images/English/English_LD-36.jpeg'),
    english37_ld: require('./Assets/Images/English/English_LD-37.png'),
    english38_ld: require('./Assets/Images/English/English_LD-38.png'),
    english39_ld: require('./Assets/Images/English/English_LD-39.png'),
    english40_ld: require('./Assets/Images/English/English_LD-40.png'),
    english41_ld: require('./Assets/Images/English/English_LD-41.jpeg'),
    english42_ld: require('./Assets/Images/English/English_LD-42.png'),
    english43_ld: require('./Assets/Images/English/English_LD-43.png'),
    english44_ld: require('./Assets/Images/English/English_LD-44.jpg'),
    english45_ld: require('./Assets/Images/English/English_LD-45.jpg'),
    english46_ld: require('./Assets/Images/English/English_LD-46.jpg'),
    english47_ld: require('./Assets/Images/English/English_LD-47.jpg'),
    english48_ld: require('./Assets/Images/English/English_LD-48.jpg'),
    english49_ld: require('./Assets/Images/English/English_LD-49.jpg'),
    english50_ld: require('./Assets/Images/English/English_LD-50.jpg'),
    english51_ld: require('./Assets/Images/English/English_LD-51.jpg'),
    english52_ld: require('./Assets/Images/English/English_LD-52.jpg'),
    english53_ld: require('./Assets/Images/English/English_LD-53.jpg'),
    english54_ld: require('./Assets/Images/English/English_LD-54.jpg'),
    english55_ld: require('./Assets/Images/English/English_LD-55.jpg'),
    english56_ld: require('./Assets/Images/English/English_LD-56.jpg'),
    english57_ld: require('./Assets/Images/English/English_LD-57.jpg'),
    english58_ld: require('./Assets/Images/English/English_LD-58.jpg'),
    english59_ld: require('./Assets/Images/English/English_LD-59.jpg'),
    english60_ld: require('./Assets/Images/English/English_LD-60.jpg'),
    english61_ld: require('./Assets/Images/English/English_LD-61.jpg'),
    english62_ld: require('./Assets/Images/English/English_LD-62.jpg'),
    english63_ld: require('./Assets/Images/English/English_LD-63.jpg'),
    english64_ld: require('./Assets/Images/English/English_LD-64.jpg'),
    english65_ld: require('./Assets/Images/English/English_LD-65.png'),
    english66_ld: require('./Assets/Images/English/English_LD-66.png'),
    english67_ld: require('./Assets/Images/English/English_LD-67.png'),
    english68_ld: require('./Assets/Images/English/English_LD-68.png'),
    english69_ld: require('./Assets/Images/English/English_LD-69.png'),
    english70_ld: require('./Assets/Images/English/English_LD-70.png'),
    english71_ld: require('./Assets/Images/English/English_LD-71.png'),
    english72_ld: require('./Assets/Images/English/English_LD-72.png'),
    english73_ld: require('./Assets/Images/English/English_LD-73.png'),
    english74_ld: require('./Assets/Images/English/English_LD-74.png'),
    english75_ld: require('./Assets/Images/English/English_LD-75.png'),
    english76_ld: require('./Assets/Images/English/English_LD-76.png'),
    english77_ld: require('./Assets/Images/English/English_LD-77.png'),
    english78_ld: require('./Assets/Images/English/English_LD-78.png'),
    english79_ld: require('./Assets/Images/English/English_LD-79.png'),
    english80_ld: require('./Assets/Images/English/English_LD-80.png'),

    hindi1_hd: require('./Assets/Images/Hindi/Hindi_HD-1.jpeg'),
    hindi2_hd: require('./Assets/Images/Hindi/Hindi_HD-2.jpeg'),
    hindi3_hd: require('./Assets/Images/Hindi/Hindi_HD-3.jpeg'),
    hindi4_hd: require('./Assets/Images/Hindi/Hindi_HD-4.jpg'),
    hindi5_hd: require('./Assets/Images/Hindi/Hindi_HD-5.jpg'),
    hindi6_hd: require('./Assets/Images/Hindi/Hindi_HD-6.jpg'),
    hindi7_hd: require('./Assets/Images/Hindi/Hindi_HD-7.jpeg'),
    hindi8_hd: require('./Assets/Images/Hindi/Hindi_HD-8.jpeg'),
    hindi10_hd: require('./Assets/Images/Hindi/Hindi_HD-10.pdf'),
    hindi11_hd: require('./Assets/Images/Hindi/Hindi_HD-11.pdf'),
    hindi12_hd: require('./Assets/Images/Hindi/Hindi_HD-12.jpg'),
    hindi13_hd: require('./Assets/Images/Hindi/Hindi_HD-13.pdf'),
    hindi14_hd: require('./Assets/Images/Hindi/Hindi_HD-14.pdf'),
    hindi15_hd: require('./Assets/Images/Hindi/Hindi_HD-15.pdf'),
    hindi16_hd: require('./Assets/Images/Hindi/Hindi_HD-16.pdf'),
    hindi17_hd: require('./Assets/Images/Hindi/Hindi_HD-17.pdf'),
    hindi18_hd: require('./Assets/Images/Hindi/Hindi_HD-18.pdf'),
    hindi19_hd: require('./Assets/Images/Hindi/Hindi_HD-19.pdf'),
    hindi21_hd: require('./Assets/Images/Hindi/Hindi_HD-21.pdf'),
    hindi22_hd: require('./Assets/Images/Hindi/Hindi_HD-22.pdf'),
    hindi23_hd: require('./Assets/Images/Hindi/Hindi_HD-23.pdf'),
    hindi25_hd: require('./Assets/Images/Hindi/Hindi_HD-25.pdf'),
    hindi26_hd: require('./Assets/Images/Hindi/Hindi_HD-26.pdf'),
    hindi27_hd: require('./Assets/Images/Hindi/Hindi_HD-27.pdf'),
    hindi28_hd: require('./Assets/Images/Hindi/Hindi_HD-28.pdf'),
    hindi29_hd: require('./Assets/Images/Hindi/Hindi_HD-29.pdf'),
    hindi30_hd: require('./Assets/Images/Hindi/Hindi_HD-30.pdf'),
    hindi31_hd: require('./Assets/Images/Hindi/Hindi_HD-31.pdf'),
    hindi32_hd: require('./Assets/Images/Hindi/Hindi_HD-32.pdf'),
    hindi33_hd: require('./Assets/Images/Hindi/Hindi_HD-33.pdf'),
    hindi34_hd: require('./Assets/Images/Hindi/Hindi_HD-34.pdf'),
    hindi35_hd: require('./Assets/Images/Hindi/Hindi_HD-35.pdf'),
    hindi36_hd: require('./Assets/Images/Hindi/Hindi_HD-36.pdf'),
    hindi37_hd: require('./Assets/Images/Hindi/Hindi_HD-37.pdf'),
    hindi38_hd: require('./Assets/Images/Hindi/Hindi_HD-38.pdf'),
    hindi39_hd: require('./Assets/Images/Hindi/Hindi_HD-39.pdf'),
    hindi40_hd: require('./Assets/Images/Hindi/Hindi_HD-40.pdf'),
    hindi41_hd: require('./Assets/Images/Hindi/Hindi_HD-41.pdf'),
    hindi42_hd: require('./Assets/Images/Hindi/Hindi_HD-42.pdf'),
    hindi43_hd: require('./Assets/Images/Hindi/Hindi_HD-43.pdf'),
    hindi44_hd: require('./Assets/Images/Hindi/Hindi_HD-44.pdf'),
    hindi45_hd: require('./Assets/Images/Hindi/Hindi_HD-45.pdf'),
    hindi46_hd: require('./Assets/Images/Hindi/Hindi_HD-46.pdf'),
    hindi47_hd: require('./Assets/Images/Hindi/Hindi_HD-47.pdf'),
    hindi48_hd: require('./Assets/Images/Hindi/Hindi_HD-48.pdf'),
    hindi49_hd: require('./Assets/Images/Hindi/Hindi_HD-49.pdf'),
    hindi50_hd: require('./Assets/Images/Hindi/Hindi_HD-50.pdf'),
    hindi51_hd: require('./Assets/Images/Hindi/Hindi_HD-51.pdf'),
    hindi52_hd: require('./Assets/Images/Hindi/Hindi_HD-52.pdf'),
    hindi53_hd: require('./Assets/Images/Hindi/Hindi_HD-53.pdf'),
    hindi54_hd: require('./Assets/Images/Hindi/Hindi_HD-54.pdf'),
    hindi55_hd: require('./Assets/Images/Hindi/Hindi_HD-55.pdf'),
    hindi56_hd: require('./Assets/Images/Hindi/Hindi_HD-56.pdf'),
    hindi57_hd: require('./Assets/Images/Hindi/Hindi_HD-57.pdf'),
    hindi58_hd: require('./Assets/Images/Hindi/Hindi_HD-58.pdf'),
    hindi59_hd: require('./Assets/Images/Hindi/Hindi_HD-59.pdf'),
    hindi60_hd: require('./Assets/Images/Hindi/Hindi_HD-60.pdf'),
    hindi61_hd: require('./Assets/Images/Hindi/Hindi_HD-61.pdf'),
    hindi62_hd: require('./Assets/Images/Hindi/Hindi_HD-62.pdf'),
    hindi63_hd: require('./Assets/Images/Hindi/Hindi_HD-63.pdf'),
    hindi64_hd: require('./Assets/Images/Hindi/Hindi_HD-64.pdf'),
    hindi65_hd: require('./Assets/Images/Hindi/Hindi_HD-65.pdf'),
    hindi66_hd: require('./Assets/Images/Hindi/Hindi_HD-66.pdf'),
    hindi67_hd: require('./Assets/Images/Hindi/Hindi_HD-67.pdf'),
    hindi68_hd: require('./Assets/Images/Hindi/Hindi_HD-68.pdf'),
    hindi69_hd: require('./Assets/Images/Hindi/Hindi_HD-69.pdf'),

    hindi1_ld: require('./Assets/Images/Hindi/Hindi_LD-1.jpg'),
    hindi2_ld: require('./Assets/Images/Hindi/Hindi_LD-2.jpg'),
    hindi3_ld: require('./Assets/Images/Hindi/Hindi_LD-3.jpg'),
    hindi4_ld: require('./Assets/Images/Hindi/Hindi_LD-4.jpg'),
    hindi5_ld: require('./Assets/Images/Hindi/Hindi_LD-5.jpg'),
    hindi6_ld: require('./Assets/Images/Hindi/Hindi_LD-6.jpg'),
    hindi7_ld: require('./Assets/Images/Hindi/Hindi_LD-7.jpeg'),
    hindi8_ld: require('./Assets/Images/Hindi/Hindi_LD-8.jpeg'),
    hindi10_ld: require('./Assets/Images/Hindi/Hindi_LD-10.png'),
    hindi11_ld: require('./Assets/Images/Hindi/Hindi_LD-11.png'),
    hindi12_ld: require('./Assets/Images/Hindi/Hindi_LD-12.jpg'),
    hindi13_ld: require('./Assets/Images/Hindi/Hindi_LD-13.png'),
    hindi14_ld: require('./Assets/Images/Hindi/Hindi_LD-14.png'),
    hindi15_ld: require('./Assets/Images/Hindi/Hindi_LD-15.png'),
    hindi16_ld: require('./Assets/Images/Hindi/Hindi_LD-16.png'),
    hindi17_ld: require('./Assets/Images/Hindi/Hindi_LD-17.png'),
    hindi18_ld: require('./Assets/Images/Hindi/Hindi_LD-18.png'),
    hindi19_ld: require('./Assets/Images/Hindi/Hindi_LD-19.png'),
    hindi21_ld: require('./Assets/Images/Hindi/Hindi_LD-21.png'),
    hindi22_ld: require('./Assets/Images/Hindi/Hindi_LD-22.png'),
    hindi23_ld: require('./Assets/Images/Hindi/Hindi_LD-23.jpeg'),
    hindi25_ld: require('./Assets/Images/Hindi/Hindi_LD-25.png'),
    hindi26_ld: require('./Assets/Images/Hindi/Hindi_LD-26.png'),
    hindi27_ld: require('./Assets/Images/Hindi/Hindi_LD-27.png'),
    hindi28_ld: require('./Assets/Images/Hindi/Hindi_LD-28.png'),
    hindi29_ld: require('./Assets/Images/Hindi/Hindi_LD-29.jpeg'),
    hindi30_ld: require('./Assets/Images/Hindi/Hindi_LD-30.png'),
    hindi31_ld: require('./Assets/Images/Hindi/Hindi_LD-31.png'),
    hindi32_ld: require('./Assets/Images/Hindi/Hindi_LD-32.jpg'),
    hindi33_ld: require('./Assets/Images/Hindi/Hindi_LD-33.jpg'),
    hindi34_ld: require('./Assets/Images/Hindi/Hindi_LD-34.jpg'),
    hindi35_ld: require('./Assets/Images/Hindi/Hindi_LD-35.jpg'),
    hindi36_ld: require('./Assets/Images/Hindi/Hindi_LD-36.jpg'),
    hindi37_ld: require('./Assets/Images/Hindi/Hindi_LD-37.jpg'),
    hindi38_ld: require('./Assets/Images/Hindi/Hindi_LD-38.jpg'),
    hindi39_ld: require('./Assets/Images/Hindi/Hindi_LD-39.jpg'),
    hindi40_ld: require('./Assets/Images/Hindi/Hindi_LD-40.jpg'),
    hindi41_ld: require('./Assets/Images/Hindi/Hindi_LD-41.jpg'),
    hindi42_ld: require('./Assets/Images/Hindi/Hindi_LD-42.jpg'),
    hindi43_ld: require('./Assets/Images/Hindi/Hindi_LD-43.jpg'),
    hindi44_ld: require('./Assets/Images/Hindi/Hindi_LD-44.jpg'),
    hindi45_ld: require('./Assets/Images/Hindi/Hindi_LD-45.jpg'),
    hindi46_ld: require('./Assets/Images/Hindi/Hindi_LD-46.jpg'),
    hindi47_ld: require('./Assets/Images/Hindi/Hindi_LD-47.jpg'),
    hindi48_ld: require('./Assets/Images/Hindi/Hindi_LD-48.jpg'),
    hindi49_ld: require('./Assets/Images/Hindi/Hindi_LD-49.jpg'),
    hindi50_ld: require('./Assets/Images/Hindi/Hindi_LD-50.png'),
    hindi51_ld: require('./Assets/Images/Hindi/Hindi_LD-51.png'),
    hindi52_ld: require('./Assets/Images/Hindi/Hindi_LD-52.png'),
    hindi53_ld: require('./Assets/Images/Hindi/Hindi_LD-53.png'),
    hindi54_ld: require('./Assets/Images/Hindi/Hindi_LD-54.png'),
    hindi55_ld: require('./Assets/Images/Hindi/Hindi_LD-55.png'),
    hindi56_ld: require('./Assets/Images/Hindi/Hindi_LD-56.png'),
    hindi57_ld: require('./Assets/Images/Hindi/Hindi_LD-57.png'),
    hindi58_ld: require('./Assets/Images/Hindi/Hindi_LD-58.png'),
    hindi59_ld: require('./Assets/Images/Hindi/Hindi_LD-59.png'),
    hindi60_ld: require('./Assets/Images/Hindi/Hindi_LD-60.png'),
    hindi61_ld: require('./Assets/Images/Hindi/Hindi_LD-61.png'),
    hindi62_ld: require('./Assets/Images/Hindi/Hindi_LD-62.png'),
    hindi63_ld: require('./Assets/Images/Hindi/Hindi_LD-63.png'),
    hindi64_ld: require('./Assets/Images/Hindi/Hindi_LD-64.png'),
    hindi65_ld: require('./Assets/Images/Hindi/Hindi_LD-65.png'),
    hindi66_ld: require('./Assets/Images/Hindi/Hindi_LD-66.png'),
    hindi67_ld: require('./Assets/Images/Hindi/Hindi_LD-67.png'),
    hindi68_ld: require('./Assets/Images/Hindi/Hindi_LD-68.png'),
    hindi69_ld: require('./Assets/Images/Hindi/Hindi_LD-69.png'),

    tagalog1_hd: require('./Assets/Images/Tagalog/Tagalog_HD-1.jpeg'),
    tagalog2_hd: require('./Assets/Images/Tagalog/Tagalog_HD-2.jpeg'),
    tagalog3_hd: require('./Assets/Images/Tagalog/Tagalog_HD-3.jpeg'),
    tagalog4_hd: require('./Assets/Images/Tagalog/Tagalog_HD-4.jpg'),
    tagalog5_hd: require('./Assets/Images/Tagalog/Tagalog_HD-5.jpg'),
    tagalog6_hd: require('./Assets/Images/Tagalog/Tagalog_HD-6.jpg'),
    tagalog7_hd: require('./Assets/Images/Tagalog/Tagalog_HD-7.jpeg'),
    tagalog8_hd: require('./Assets/Images/Tagalog/Tagalog_HD-8.jpeg'),
    tagalog10_hd: require('./Assets/Images/Tagalog/Tagalog_HD-10.pdf'),
    tagalog11_hd: require('./Assets/Images/Tagalog/Tagalog_HD-11.pdf'),
    tagalog12_hd: require('./Assets/Images/Tagalog/Tagalog_HD-12.jpg'),
    tagalog13_hd: require('./Assets/Images/Tagalog/Tagalog_HD-13.pdf'),
    tagalog14_hd: require('./Assets/Images/Tagalog/Tagalog_HD-14.pdf'),
    tagalog15_hd: require('./Assets/Images/Tagalog/Tagalog_HD-15.pdf'),
    tagalog16_hd: require('./Assets/Images/Tagalog/Tagalog_HD-16.pdf'),
    tagalog17_hd: require('./Assets/Images/Tagalog/Tagalog_HD-17.pdf'),
    tagalog18_hd: require('./Assets/Images/Tagalog/Tagalog_HD-18.pdf'),
    tagalog19_hd: require('./Assets/Images/Tagalog/Tagalog_HD-19.pdf'),
    tagalog21_hd: require('./Assets/Images/Tagalog/Tagalog_HD-21.pdf'),
    tagalog22_hd: require('./Assets/Images/Tagalog/Tagalog_HD-22.pdf'),
    tagalog23_hd: require('./Assets/Images/Tagalog/Tagalog_HD-23.pdf'),
    tagalog24_hd: require('./Assets/Images/Tagalog/Tagalog_HD-24.pdf'),
    tagalog25_hd: require('./Assets/Images/Tagalog/Tagalog_HD-25.pdf'),
    tagalog26_hd: require('./Assets/Images/Tagalog/Tagalog_HD-26.pdf'),
    tagalog27_hd: require('./Assets/Images/Tagalog/Tagalog_HD-27.pdf'),
    tagalog28_hd: require('./Assets/Images/Tagalog/Tagalog_HD-28.pdf'),
    tagalog29_hd: require('./Assets/Images/Tagalog/Tagalog_HD-29.pdf'),
    tagalog30_hd: require('./Assets/Images/Tagalog/Tagalog_HD-30.pdf'),
    tagalog31_hd: require('./Assets/Images/Tagalog/Tagalog_HD-31.pdf'),
    tagalog32_hd: require('./Assets/Images/Tagalog/Tagalog_HD-32.pdf'),
    tagalog33_hd: require('./Assets/Images/Tagalog/Tagalog_HD-33.pdf'),
    tagalog34_hd: require('./Assets/Images/Tagalog/Tagalog_HD-34.pdf'),
    tagalog35_hd: require('./Assets/Images/Tagalog/Tagalog_HD-35.pdf'),
    tagalog36_hd: require('./Assets/Images/Tagalog/Tagalog_HD-36.pdf'),
    tagalog37_hd: require('./Assets/Images/Tagalog/Tagalog_HD-37.pdf'),
    tagalog38_hd: require('./Assets/Images/Tagalog/Tagalog_HD-38.pdf'),
    tagalog39_hd: require('./Assets/Images/Tagalog/Tagalog_HD-39.pdf'),
    tagalog40_hd: require('./Assets/Images/Tagalog/Tagalog_HD-40.pdf'),
    tagalog41_hd: require('./Assets/Images/Tagalog/Tagalog_HD-41.pdf'),
    tagalog42_hd: require('./Assets/Images/Tagalog/Tagalog_HD-42.pdf'),
    tagalog43_hd: require('./Assets/Images/Tagalog/Tagalog_HD-43.pdf'),
    tagalog44_hd: require('./Assets/Images/Tagalog/Tagalog_HD-44.pdf'),
    tagalog45_hd: require('./Assets/Images/Tagalog/Tagalog_HD-45.pdf'),
    tagalog46_hd: require('./Assets/Images/Tagalog/Tagalog_HD-46.pdf'),
    tagalog47_hd: require('./Assets/Images/Tagalog/Tagalog_HD-47.pdf'),
    tagalog48_hd: require('./Assets/Images/Tagalog/Tagalog_HD-48.pdf'),
    tagalog49_hd: require('./Assets/Images/Tagalog/Tagalog_HD-49.pdf'),
    tagalog50_hd: require('./Assets/Images/Tagalog/Tagalog_HD-50.pdf'),
    tagalog51_hd: require('./Assets/Images/Tagalog/Tagalog_HD-51.pdf'),
    tagalog52_hd: require('./Assets/Images/Tagalog/Tagalog_HD-52.pdf'),
    tagalog53_hd: require('./Assets/Images/Tagalog/Tagalog_HD-53.pdf'),
    tagalog54_hd: require('./Assets/Images/Tagalog/Tagalog_HD-54.pdf'),
    tagalog55_hd: require('./Assets/Images/Tagalog/Tagalog_HD-55.pdf'),
    tagalog56_hd: require('./Assets/Images/Tagalog/Tagalog_HD-56.pdf'),
    tagalog57_hd: require('./Assets/Images/Tagalog/Tagalog_HD-57.pdf'),
    tagalog58_hd: require('./Assets/Images/Tagalog/Tagalog_HD-58.pdf'),
    tagalog59_hd: require('./Assets/Images/Tagalog/Tagalog_HD-59.pdf'),
    tagalog60_hd: require('./Assets/Images/Tagalog/Tagalog_HD-60.pdf'),
    tagalog61_hd: require('./Assets/Images/Tagalog/Tagalog_HD-61.pdf'),
    tagalog62_hd: require('./Assets/Images/Tagalog/Tagalog_HD-62.pdf'),
    tagalog63_hd: require('./Assets/Images/Tagalog/Tagalog_HD-63.pdf'),
    tagalog64_hd: require('./Assets/Images/Tagalog/Tagalog_HD-64.pdf'),
    tagalog65_hd: require('./Assets/Images/Tagalog/Tagalog_HD-65.pdf'),
    tagalog66_hd: require('./Assets/Images/Tagalog/Tagalog_HD-66.pdf'),
    tagalog67_hd: require('./Assets/Images/Tagalog/Tagalog_HD-67.pdf'),
    tagalog68_hd: require('./Assets/Images/Tagalog/Tagalog_HD-68.pdf'),


    tagalog1_ld: require('./Assets/Images/Tagalog/Tagalog_LD-1.jpg'),
    tagalog2_ld: require('./Assets/Images/Tagalog/Tagalog_LD-2.jpg'),
    tagalog3_ld: require('./Assets/Images/Tagalog/Tagalog_LD-3.jpg'),
    tagalog4_ld: require('./Assets/Images/Tagalog/Tagalog_LD-4.jpg'),
    tagalog5_ld: require('./Assets/Images/Tagalog/Tagalog_LD-5.jpg'),
    tagalog6_ld: require('./Assets/Images/Tagalog/Tagalog_LD-6.jpg'),
    tagalog7_ld: require('./Assets/Images/Tagalog/Tagalog_LD-7.jpeg'),
    tagalog8_ld: require('./Assets/Images/Tagalog/Tagalog_LD-8.jpeg'),
    tagalog10_ld: require('./Assets/Images/Tagalog/Tagalog_LD-10.png'),
    tagalog11_ld: require('./Assets/Images/Tagalog/Tagalog_LD-11.png'),
    tagalog12_ld: require('./Assets/Images/Tagalog/Tagalog_LD-12.jpg'),
    tagalog13_ld: require('./Assets/Images/Tagalog/Tagalog_LD-13.png'),
    tagalog14_ld: require('./Assets/Images/Tagalog/Tagalog_LD-14.png'),
    tagalog15_ld: require('./Assets/Images/Tagalog/Tagalog_LD-15.png'),
    tagalog16_ld: require('./Assets/Images/Tagalog/Tagalog_LD-16.png'),
    tagalog17_ld: require('./Assets/Images/Tagalog/Tagalog_LD-17.png'),
    tagalog18_ld: require('./Assets/Images/Tagalog/Tagalog_LD-18.png'),
    tagalog19_ld: require('./Assets/Images/Tagalog/Tagalog_LD-19.png'),
    tagalog21_ld: require('./Assets/Images/Tagalog/Tagalog_LD-21.png'),
    tagalog22_ld: require('./Assets/Images/Tagalog/Tagalog_LD-22.png'),
    tagalog23_ld: require('./Assets/Images/Tagalog/Tagalog_LD-23.jpeg'),
    tagalog24_ld: require('./Assets/Images/Tagalog/Tagalog_LD-24.png'),
    tagalog25_ld: require('./Assets/Images/Tagalog/Tagalog_LD-25.png'),
    tagalog26_ld: require('./Assets/Images/Tagalog/Tagalog_LD-26.jpeg'),
    tagalog27_ld: require('./Assets/Images/Tagalog/Tagalog_LD-27.jpeg'),
    tagalog28_ld: require('./Assets/Images/Tagalog/Tagalog_LD-28.jpeg'),
    tagalog29_ld: require('./Assets/Images/Tagalog/Tagalog_LD-29.jpg'),
    tagalog30_ld: require('./Assets/Images/Tagalog/Tagalog_LD-30.jpeg'),
    tagalog31_ld: require('./Assets/Images/Tagalog/Tagalog_LD-31.jpg'),
    tagalog32_ld: require('./Assets/Images/Tagalog/Tagalog_LD-32.jpg'),
    tagalog33_ld: require('./Assets/Images/Tagalog/Tagalog_LD-33.jpg'),
    tagalog34_ld: require('./Assets/Images/Tagalog/Tagalog_LD-34.jpg'),
    tagalog35_ld: require('./Assets/Images/Tagalog/Tagalog_LD-35.jpg'),
    tagalog36_ld: require('./Assets/Images/Tagalog/Tagalog_LD-36.jpg'),
    tagalog37_ld: require('./Assets/Images/Tagalog/Tagalog_LD-37.jpg'),
    tagalog38_ld: require('./Assets/Images/Tagalog/Tagalog_LD-38.jpg'),
    tagalog39_ld: require('./Assets/Images/Tagalog/Tagalog_LD-39.jpg'),
    tagalog40_ld: require('./Assets/Images/Tagalog/Tagalog_LD-40.jpg'),
    tagalog41_ld: require('./Assets/Images/Tagalog/Tagalog_LD-41.jpg'),
    tagalog42_ld: require('./Assets/Images/Tagalog/Tagalog_LD-42.jpg'),
    tagalog43_ld: require('./Assets/Images/Tagalog/Tagalog_LD-43.jpg'),
    tagalog44_ld: require('./Assets/Images/Tagalog/Tagalog_LD-44.jpg'),
    tagalog45_ld: require('./Assets/Images/Tagalog/Tagalog_LD-45.jpg'),
    tagalog46_ld: require('./Assets/Images/Tagalog/Tagalog_LD-46.jpg'),
    tagalog47_ld: require('./Assets/Images/Tagalog/Tagalog_LD-47.jpg'),
    tagalog48_ld: require('./Assets/Images/Tagalog/Tagalog_LD-48.jpg'),
    tagalog49_ld: require('./Assets/Images/Tagalog/Tagalog_LD-49.png'),
    tagalog50_ld: require('./Assets/Images/Tagalog/Tagalog_LD-50.png'),
    tagalog51_ld: require('./Assets/Images/Tagalog/Tagalog_LD-51.png'),
    tagalog52_ld: require('./Assets/Images/Tagalog/Tagalog_LD-52.png'),
    tagalog53_ld: require('./Assets/Images/Tagalog/Tagalog_LD-53.png'),
    tagalog54_ld: require('./Assets/Images/Tagalog/Tagalog_LD-54.png'),
    tagalog55_ld: require('./Assets/Images/Tagalog/Tagalog_LD-55.png'),
    tagalog56_ld: require('./Assets/Images/Tagalog/Tagalog_LD-56.png'),
    tagalog57_ld: require('./Assets/Images/Tagalog/Tagalog_LD-57.png'),
    tagalog58_ld: require('./Assets/Images/Tagalog/Tagalog_LD-58.png'),
    tagalog59_ld: require('./Assets/Images/Tagalog/Tagalog_LD-59.png'),
    tagalog60_ld: require('./Assets/Images/Tagalog/Tagalog_LD-60.png'),
    tagalog61_ld: require('./Assets/Images/Tagalog/Tagalog_LD-61.png'),
    tagalog62_ld: require('./Assets/Images/Tagalog/Tagalog_LD-62.png'),
    tagalog63_ld: require('./Assets/Images/Tagalog/Tagalog_LD-63.png'),
    tagalog64_ld: require('./Assets/Images/Tagalog/Tagalog_LD-64.png'),
    tagalog65_ld: require('./Assets/Images/Tagalog/Tagalog_LD-65.png'),
    tagalog66_ld: require('./Assets/Images/Tagalog/Tagalog_LD-66.png'),
    tagalog67_ld: require('./Assets/Images/Tagalog/Tagalog_LD-67.png'),
    tagalog68_ld: require('./Assets/Images/Tagalog/Tagalog_LD-68.png'),


    urdu1_hd: require('./Assets/Images/Urdu/Urdu_HD-1.jpg'),
    urdu2_hd: require('./Assets/Images/Urdu/Urdu_HD-2.jpeg'),
    urdu3_hd: require('./Assets/Images/Urdu/Urdu_HD-3.jpg'),
    urdu4_hd: require('./Assets/Images/Urdu/Urdu_HD-4.jpg'),
    urdu5_hd: require('./Assets/Images/Urdu/Urdu_HD-5.jpg'),
    urdu6_hd: require('./Assets/Images/Urdu/Urdu_HD-6.jpg'),
    urdu8_hd: require('./Assets/Images/Urdu/Urdu_HD-8.jpeg'),
    urdu10_hd: require('./Assets/Images/Urdu/Urdu_HD-10.pdf'),
    urdu11_hd: require('./Assets/Images/Urdu/Urdu_HD-11.pdf'),
    urdu12_hd: require('./Assets/Images/Urdu/Urdu_HD-12.jpg'),
    urdu13_hd: require('./Assets/Images/Urdu/Urdu_HD-13.pdf'),
    urdu15_hd: require('./Assets/Images/Urdu/Urdu_HD-15.pdf'),
    urdu16_hd: require('./Assets/Images/Urdu/Urdu_HD-16.pdf'),
    urdu17_hd: require('./Assets/Images/Urdu/Urdu_HD-17.pdf'),
    urdu18_hd: require('./Assets/Images/Urdu/Urdu_HD-18.pdf'),
    urdu19_hd: require('./Assets/Images/Urdu/Urdu_HD-19.pdf'),
    urdu20_hd: require('./Assets/Images/Urdu/Urdu_HD-20.pdf'),
    urdu21_hd: require('./Assets/Images/Urdu/Urdu_HD-21.pdf'),
    urdu22_hd: require('./Assets/Images/Urdu/Urdu_HD-22.pdf'),
    urdu23_hd: require('./Assets/Images/Urdu/Urdu_HD-23.pdf'),
    urdu24_hd: require('./Assets/Images/Urdu/Urdu_HD-24.pdf'),
    urdu25_hd: require('./Assets/Images/Urdu/Urdu_HD-25.pdf'),
    urdu26_hd: require('./Assets/Images/Urdu/Urdu_HD-26.pdf'),
    urdu27_hd: require('./Assets/Images/Urdu/Urdu_HD-27.png'),
    urdu28_hd: require('./Assets/Images/Urdu/Urdu_HD-28.pdf'),
    urdu29_hd: require('./Assets/Images/Urdu/Urdu_HD-29.pdf'),
    urdu30_hd: require('./Assets/Images/Urdu/Urdu_HD-30.pdf'),
    urdu31_hd: require('./Assets/Images/Urdu/Urdu_HD-31.pdf'),
    urdu32_hd: require('./Assets/Images/Urdu/Urdu_HD-32.pdf'),
    urdu33_hd: require('./Assets/Images/Urdu/Urdu_HD-33.pdf'),
    urdu34_hd: require('./Assets/Images/Urdu/Urdu_HD-34.pdf'),
    urdu35_hd: require('./Assets/Images/Urdu/Urdu_HD-35.pdf'),
    urdu36_hd: require('./Assets/Images/Urdu/Urdu_HD-36.pdf'),
    urdu37_hd: require('./Assets/Images/Urdu/Urdu_HD-37.pdf'),
    urdu38_hd: require('./Assets/Images/Urdu/Urdu_HD-38.pdf'),
    urdu39_hd: require('./Assets/Images/Urdu/Urdu_HD-39.pdf'),
    urdu40_hd: require('./Assets/Images/Urdu/Urdu_HD-40.pdf'),
    urdu41_hd: require('./Assets/Images/Urdu/Urdu_HD-41.pdf'),
    urdu42_hd: require('./Assets/Images/Urdu/Urdu_HD-42.pdf'),
    urdu43_hd: require('./Assets/Images/Urdu/Urdu_HD-43.pdf'),
    urdu44_hd: require('./Assets/Images/Urdu/Urdu_HD-44.pdf'),
    urdu45_hd: require('./Assets/Images/Urdu/Urdu_HD-45.pdf'),
    urdu46_hd: require('./Assets/Images/Urdu/Urdu_HD-46.pdf'),
    urdu47_hd: require('./Assets/Images/Urdu/Urdu_HD-47.pdf'),
    urdu48_hd: require('./Assets/Images/Urdu/Urdu_HD-48.pdf'),
    urdu49_hd: require('./Assets/Images/Urdu/Urdu_HD-49.pdf'),
    urdu50_hd: require('./Assets/Images/Urdu/Urdu_HD-50.pdf'),
    urdu51_hd: require('./Assets/Images/Urdu/Urdu_HD-51.pdf'),
    urdu52_hd: require('./Assets/Images/Urdu/Urdu_HD-52.pdf'),
    urdu53_hd: require('./Assets/Images/Urdu/Urdu_HD-53.pdf'),
    urdu54_hd: require('./Assets/Images/Urdu/Urdu_HD-54.pdf'),
    urdu55_hd: require('./Assets/Images/Urdu/Urdu_HD-55.pdf'),
    urdu56_hd: require('./Assets/Images/Urdu/Urdu_HD-56.pdf'),
    urdu57_hd: require('./Assets/Images/Urdu/Urdu_HD-57.pdf'),
    urdu58_hd: require('./Assets/Images/Urdu/Urdu_HD-58.pdf'),
    urdu59_hd: require('./Assets/Images/Urdu/Urdu_HD-59.pdf'),
    urdu60_hd: require('./Assets/Images/Urdu/Urdu_HD-60.pdf'),
    urdu61_hd: require('./Assets/Images/Urdu/Urdu_HD-61.pdf'),
    urdu62_hd: require('./Assets/Images/Urdu/Urdu_HD-62.pdf'),
    urdu63_hd: require('./Assets/Images/Urdu/Urdu_HD-63.pdf'),
    urdu64_hd: require('./Assets/Images/Urdu/Urdu_HD-64.pdf'),
    urdu65_hd: require('./Assets/Images/Urdu/Urdu_HD-65.pdf'),
    urdu66_hd: require('./Assets/Images/Urdu/Urdu_HD-66.pdf'),
    urdu67_hd: require('./Assets/Images/Urdu/Urdu_HD-67.pdf'),
    urdu68_hd: require('./Assets/Images/Urdu/Urdu_HD-68.pdf'),
    urdu69_hd: require('./Assets/Images/Urdu/Urdu_HD-69.pdf'),

    urdu1_ld: require('./Assets/Images/Urdu/Urdu_LD-1.jpg'),
    urdu2_ld: require('./Assets/Images/Urdu/Urdu_LD-2.jpg'),
    urdu3_ld: require('./Assets/Images/Urdu/Urdu_LD-3.jpg'),
    urdu4_ld: require('./Assets/Images/Urdu/Urdu_LD-4.jpg'),
    urdu5_ld: require('./Assets/Images/Urdu/Urdu_LD-5.jpg'),
    urdu6_ld: require('./Assets/Images/Urdu/Urdu_LD-6.jpg'),
    urdu8_ld: require('./Assets/Images/Urdu/Urdu_LD-8.jpeg'),
    urdu10_ld: require('./Assets/Images/Urdu/Urdu_LD-10.png'),
    urdu11_ld: require('./Assets/Images/Urdu/Urdu_LD-11.png'),
    urdu12_ld: require('./Assets/Images/Urdu/Urdu_LD-12.jpg'),
    urdu13_ld: require('./Assets/Images/Urdu/Urdu_LD-13.png'),
    urdu15_ld: require('./Assets/Images/Urdu/Urdu_LD-15.png'),
    urdu16_ld: require('./Assets/Images/Urdu/Urdu_LD-16.png'),
    urdu17_ld: require('./Assets/Images/Urdu/Urdu_LD-17.png'),
    urdu18_ld: require('./Assets/Images/Urdu/Urdu_LD-18.png'),
    urdu19_ld: require('./Assets/Images/Urdu/Urdu_LD-19.png'),
    urdu20_ld: require('./Assets/Images/Urdu/Urdu_LD-20.jpeg'),
    urdu21_ld: require('./Assets/Images/Urdu/Urdu_LD-21.png'),
    urdu22_ld: require('./Assets/Images/Urdu/Urdu_LD-22.png'),
    urdu23_ld: require('./Assets/Images/Urdu/Urdu_LD-23.png'),
    urdu24_ld: require('./Assets/Images/Urdu/Urdu_LD-24.png'),
    urdu25_ld: require('./Assets/Images/Urdu/Urdu_LD-25.jpeg'),
    urdu26_ld: require('./Assets/Images/Urdu/Urdu_LD-26.png'),
    urdu27_ld: require('./Assets/Images/Urdu/Urdu_LD-27.png'),
    urdu28_ld: require('./Assets/Images/Urdu/Urdu_LD-28.jpeg'),
    urdu29_ld: require('./Assets/Images/Urdu/Urdu_LD-29.jpg'),
    urdu30_ld: require('./Assets/Images/Urdu/Urdu_LD-30.jpg'),
    urdu31_ld: require('./Assets/Images/Urdu/Urdu_LD-31.jpg'),
    urdu32_ld: require('./Assets/Images/Urdu/Urdu_LD-32.jpg'),
    urdu33_ld: require('./Assets/Images/Urdu/Urdu_LD-33.jpg'),
    urdu34_ld: require('./Assets/Images/Urdu/Urdu_LD-34.jpg'),
    urdu35_ld: require('./Assets/Images/Urdu/Urdu_LD-35.jpg'),
    urdu36_ld: require('./Assets/Images/Urdu/Urdu_LD-36.jpg'),
    urdu37_ld: require('./Assets/Images/Urdu/Urdu_LD-37.jpg'),
    urdu38_ld: require('./Assets/Images/Urdu/Urdu_LD-38.jpg'),
    urdu39_ld: require('./Assets/Images/Urdu/Urdu_LD-39.jpg'),
    urdu40_ld: require('./Assets/Images/Urdu/Urdu_LD-40.jpg'),
    urdu41_ld: require('./Assets/Images/Urdu/Urdu_LD-41.jpg'),
    urdu42_ld: require('./Assets/Images/Urdu/Urdu_LD-42.jpg'),
    urdu43_ld: require('./Assets/Images/Urdu/Urdu_LD-43.jpg'),
    urdu44_ld: require('./Assets/Images/Urdu/Urdu_LD-44.jpg'),
    urdu45_ld: require('./Assets/Images/Urdu/Urdu_LD-45.jpg'),
    urdu46_ld: require('./Assets/Images/Urdu/Urdu_LD-46.jpg'),
    urdu47_ld: require('./Assets/Images/Urdu/Urdu_LD-47.jpg'),
    urdu48_ld: require('./Assets/Images/Urdu/Urdu_LD-48.jpg'),
    urdu49_ld: require('./Assets/Images/Urdu/Urdu_LD-49.jpg'),
    urdu50_ld: require('./Assets/Images/Urdu/Urdu_LD-50.png'),
    urdu51_ld: require('./Assets/Images/Urdu/Urdu_LD-51.png'),
    urdu52_ld: require('./Assets/Images/Urdu/Urdu_LD-52.png'),
    urdu53_ld: require('./Assets/Images/Urdu/Urdu_LD-53.png'),
    urdu54_ld: require('./Assets/Images/Urdu/Urdu_LD-54.jpeg'),
    urdu55_ld: require('./Assets/Images/Urdu/Urdu_LD-55.jpeg'),
    urdu56_ld: require('./Assets/Images/Urdu/Urdu_LD-56.png'),
    urdu57_ld: require('./Assets/Images/Urdu/Urdu_LD-57.png'),
    urdu58_ld: require('./Assets/Images/Urdu/Urdu_LD-58.png'),
    urdu59_ld: require('./Assets/Images/Urdu/Urdu_LD-59.png'),
    urdu60_ld: require('./Assets/Images/Urdu/Urdu_LD-60.png'),
    urdu61_ld: require('./Assets/Images/Urdu/Urdu_LD-61.png'),
    urdu62_ld: require('./Assets/Images/Urdu/Urdu_LD-62.png'),
    urdu63_ld: require('./Assets/Images/Urdu/Urdu_LD-63.png'),
    urdu64_ld: require('./Assets/Images/Urdu/Urdu_LD-64.png'),
    urdu65_ld: require('./Assets/Images/Urdu/Urdu_LD-65.png'),
    urdu66_ld: require('./Assets/Images/Urdu/Urdu_LD-66.png'),
    urdu67_ld: require('./Assets/Images/Urdu/Urdu_LD-67.png'),
    urdu68_ld: require('./Assets/Images/Urdu/Urdu_LD-68.png'),
    urdu69_ld: require('./Assets/Images/Urdu/Urdu_LD-69.png'),

    english: require('./Assets/Images/english.svg').default,
    pakistan: require('./Assets/Images/pakistan.svg').default,
    china: require('./Assets/Images/china.svg').default,
    saudi_arabia: require('./Assets/Images/saudi-arabia.svg').default,
    bangladesh: require('./Assets/Images/bangladesh.svg').default,
    india: require('./Assets/Images/india.svg').default,
    tagalog: require('./Assets/Images/tagalog.svg').default,
    nepal: require('./Assets/Images/flag-for-nepal.svg').default,
    yt_icon: require('./Assets/Images/youtube_icon.svg').default,
    url_icon: require('./Assets/Images/url_icon.svg').default,
    url_image_1: require('./Assets/Images/url_images_1.jpeg'),
    url_image_2: require('./Assets/Images/url_images_2.jpeg'),
    url_image_3: require('./Assets/Images/url_images_3.jpeg'),

}

export const Languages = [
    {
        name: 'English',
        image: Images.english
    }, {
        name: 'اردو',
        image: Images.pakistan
    }, {
        name: 'عربى',
        image: Images.saudi_arabia
    }, {
        name: '中国人',
        image: Images.china
    }, {
        name: 'বাংলা',
        image: Images.bangladesh
    }, {
        name: 'हिन्दी',
        image: Images.india
    },
    {
        name: 'Tagalog',
        image: Images.tagalog
    },
    {
        name: 'Nepali',
        image: Images.nepal
    },
]

export const ToolBox = {
    english: [
        {
            title: "January – Social Well-being",
            image_hd: Images.english10_hd,
            image: Images.english10_ld,
        }, {
            title: "February – Cancer Prevention",
            image_hd: Images.english11_hd,
            image: Images.english10_ld,
        }, {
            title: "March – Obesity Prevention",
            image_hd: Images.english12_hd,
            image: Images.english10_ld,
        }, {
            title: "April - Ramadan",
            image_hd: Images.english13_hd,
            image: Images.english10_ld,
        }, {
            title: "May - Fatigue",
            image_hd: Images.english14_hd,
            image: Images.english10_ld,
        }, {
            title: "June – Food Safety",
            image_hd: Images.english15_hd,
            image: Images.english10_ld,
        }, {
            title: "July- Heat Stress",
            image_hd: Images.english16_hd,
            image: Images.english10_ld,
        }, {
            title: "August- Heat Stress",
            image_hd: Images.english17_hd,
            image: Images.english10_ld,
        }, {
            title: "September- Suicide Prevention",
            image_hd: Images.english18_hd,
            image: Images.english10_ld,
        }, {
            title: "October- Mental health",
            image_hd: Images.english19_hd,
            image: Images.english10_ld,
        }, {
            title: "November- Nutrition",
            image_hd: Images.english20_hd,
            image: Images.english10_ld,
        }, {
            title: "December – Winter Blues",
            image_hd: Images.english21_hd,
            image: Images.english10_ld,
        },
    ]
}
export const Blogs = {
    english: [
        {
            title: 'Recognizing Warning Signs',
            image_hd: Images.english1_hd,
            image: Images.english1_ld,
        }, {
            title: 'Managing Stress',
            image_hd: Images.english2_hd,
            image: Images.english2_ld,
        }, {
            title: 'Managing Grief',
            image_hd: Images.english3_hd,
            image: Images.english3_ld,
        }, {
            title: 'You are not Alone',
            image_hd: Images.english4_hd,
            image: Images.english4_ld,
        }, {
            title: 'You are not Alone',
            image_hd: Images.english5_hd,
            image: Images.english5_ld,
        }, {
            title: 'Feeling Down?',
            image_hd: Images.english6_hd,
            image: Images.english6_ld,
        }, {
            title: "It's okay to ask for help",
            image_hd: Images.english8_hd,
            image: Images.english8_ld,
        }, {
            title: "Benefits of Wellbeing",
            image_hd: Images.english22_hd,
            image: Images.english22_ld,
        }, {
            title: "Contractor Well-being Program",
            image_hd: Images.english23_hd,
            image: Images.english23_ld,
        }, {
            title: "Conflict Resolution Techniques",
            image_hd: Images.english24_hd,
            image: Images.english24_ld,
        }, {
            title: "Diabetes",
            image_hd: Images.english25_hd,
            image: Images.english25_ld,
        }, {
            title: "Building Social Support",
            image_hd: Images.english26_hd,
            image: Images.english26_ld,
        }, {
            title: "Growth mindset",
            image_hd: Images.english27_hd,
            image: Images.english27_ld,
        }, {
            title: "Positive Thinking",
            image_hd: Images.english28_hd,
            image: Images.english28_ld,
        }, {
            title: "PTSD",
            image_hd: Images.english29_hd,
            image: Images.english29_ld,
        }, {
            title: "Tips to help you sleep better",
            image_hd: Images.english30_hd,
            image: Images.english30_ld,
        }, {
            title: "Don't fight your battle alone",
            image_hd: Images.english31_hd,
            image: Images.english31_ld,
        }, {
            title: "Responding to stress",
            image_hd: Images.english32_hd,
            image: Images.english32_ld,
        }, {
            title: "How to create a safe space for mental health",
            image_hd: Images.english33_hd,
            image: Images.english33_ld,
        }, {
            title: "Diabetes Symptoms",
            image_hd: Images.english34_hd,
            image: Images.english34_ld,
        }, {
            title: "Breathing technique to reduce stress",
            image_hd: Images.english35_hd,
            image: Images.english35_ld,
        }, {
            title: "Achieve your best self",
            image_hd: Images.english36_hd,
            image: Images.english36_ld,
        }, {
            title: "Contractor Well-being Porgram",
            image_hd: Images.english37_hd,
            image: Images.english37_ld,
        }, {
            title: "Conflict resolution skills",
            image_hd: Images.english38_hd,
            image: Images.english38_ld,
        }, {
            title: "Know the symptoms",
            image_hd: Images.english39_hd,
            image: Images.english39_ld,
        }, {
            title: "What is fight or flight?",
            image_hd: Images.english40_hd,
            image: Images.english40_ld,
        }, {
            title: "How therapy helps",
            image_hd: Images.english41_hd,
            image: Images.english41_ld,
        }, {
            title: "Tips for maintaining mental health",
            image_hd: Images.english42_hd,
            image: Images.english42_ld,
        }, {
            title: "Sleep management",
            image_hd: Images.english43_hd,
            image: Images.english43_ld,
        },
        {
            title: "A problem shared is a problem halved",
            image_hd: Images.english44_hd,
            image: Images.english44_ld,
        },
        {
            title: "Ask a question, save a life",
            image_hd: Images.english45_hd,
            image: Images.english45_ld,
        },
        {
            title: "Broken heart",
            image_hd: Images.english46_hd,
            image: Images.english46_ld,
        },
        {
            title: "Common misconception",
            image_hd: Images.english47_hd,
            image: Images.english47_ld,
        },
        {
            title: "Contractor Passport Wallet Card to Management",
            image_hd: Images.english48_hd,
            image: Images.english48_ld,
        },
        {
            title: "Contractor-Passport Poster for Users",
            image_hd: Images.english49_hd,
            image: Images.english49_ld,
        },
        {
            title: "Contractor-Passport Wallet-Card for Users",
            image_hd: Images.english50_hd,
            image: Images.english50_ld,
        },
        {
            title: "Healthy Snacks",
            image_hd: Images.english51_hd,
            image: Images.english51_ld,
        },
        {
            title: "Management Contractor-Passport poster",
            image_hd: Images.english52_hd,
            image: Images.english52_ld,
        },
        {
            title: "Poster for WHO-5",
            image_hd: Images.english53_hd,
            image: Images.english53_ld,
        },
        {
            title: "QPR poster (with QR Codes)",
            image_hd: Images.english54_hd,
            image: Images.english54_ld,
        },
        {
            title: "Signs of Stress Aramco Poster",
            image_hd: Images.english55_hd,
            image: Images.english55_ld,
        },
        {
            title: "Tips to help prevent dehydration",
            image_hd: Images.english56_hd,
            image: Images.english56_ld,
        },
        {
            title: "Uplifting Proverb 1",
            image_hd: Images.english57_hd,
            image: Images.english57_ld,
        },
        {
            title: "Uplifting Proverb 3",
            image_hd: Images.english58_hd,
            image: Images.english58_ld,
        },
        {
            title: "When To Use Our Service",
            image_hd: Images.english59_hd,
            image: Images.english59_ld,
        },
        {
            title: "WHO-5 Sticker",
            image_hd: Images.english60_hd,
            image: Images.english60_ld,
        },
        {
            title: "Mental health skills manager",
            image_hd: Images.english61_hd,
            image: Images.english61_ld,
        },
        {
            title: "Community Values Support",
            image_hd: Images.english62_hd,
            image: Images.english62_ld,
        },
        {
            title: "Reduce Burnout",
            image_hd: Images.english63_hd,
            image: Images.english63_ld,
        },
        {
            title: "Dehydration Prevention",
            image_hd: Images.english64_hd,
            image: Images.english64_ld,
        },
        {
            title: "Management Skills for Hard Conversations-Emotional Intelligence",
            image_hd: Images.english65_hd,
            image: Images.english65_ld,
        },
        {
            title: "Overthinking",
            image_hd: Images.english66_hd,
            image: Images.english66_ld,
        },
        {
            title: "Panic Attacks",
            image_hd: Images.english67_hd,
            image: Images.english67_ld,
        },
        {
            title: "Signs of Stress",
            image_hd: Images.english68_hd,
            image: Images.english68_ld,
        },
        {
            title: "Tools to Change Habits",
            image_hd: Images.english69_hd,
            image: Images.english69_ld,
        },
        {
            title: "Financial Wellbeing",
            image_hd: Images.english70_hd,
            image: Images.english70_ld,
        },
        {
            title: "Expat Well-Being",
            image_hd: Images.english71_hd,
            image: Images.english71_ld,
        },
        {
            title: "Mindfulness, Present Moment",
            image_hd: Images.english72_hd,
            image: Images.english72_ld,
        },
        {
            title: "Heat Stress",
            image_hd: Images.english73_hd,
            image: Images.english73_ld,
        },
        {
            title: "Energy Drain",
            image_hd: Images.english74_hd,
            image: Images.english74_ld,
        },
        {
            title: "Summer Handout",
            image_hd: Images.english75_hd,
            image: Images.english75_ld,
        },
        {
            title: "Dental Hygiene",
            image_hd: Images.english76_hd,
            image: Images.english76_ld,
        },
        {
            title: "Communicating with Family",
            image_hd: Images.english77_hd,
            image: Images.english77_ld,
        },
        {
            title: "Increasing Confidence",
            image_hd: Images.english78_hd,
            image: Images.english78_ld,
        },
        {
            title: "CWP Success Stories",
            image_hd: Images.english79_hd,
            image: Images.english79_ld,
        },
        {
            title: "Physical Health and Stress",
            image_hd: Images.english80_hd,
            image: Images.english80_ld,
        },
    ],
    urdu: [
        {
            title: 'انتباہی نشانات کو پہچاننا',
            image_hd: Images.urdu1_hd,
            image: Images.urdu1_ld,
        }, {
            title: 'تناؤ / اسٹریس کا انتظام',
            image_hd: Images.urdu2_hd,
            image: Images.urdu2_ld,
        }, {
            title: 'غم کا انتظام',
            image_hd: Images.urdu3_hd,
            image: Images.urdu3_ld,
        }, {
            title: 'آپ تنہا نہیں ہیں',
            image_hd: Images.urdu4_hd,
            image: Images.urdu4_ld,
        }, {
            title: 'آپ تنہا نہیں ہیں',
            image_hd: Images.urdu5_hd,
            image: Images.urdu5_ld,
        }, {
            title: 'نیچا / مجبور محسوس کرنا؟',
            image_hd: Images.urdu6_hd,
            image: Images.urdu6_ld,
        }, {
            title: 'مدد مانگنا ٹھیک ہے',
            image_hd: Images.urdu8_hd,
            image: Images.urdu8_ld,
        }, {
            title: "نیند کی کمی کی وجہ سے کیاہو سکتا ہے؟",
            image_hd: Images.urdu10_hd,
            image: Images.urdu10_ld,
        }, {
            title: "سماجی تعاون کی کمی باعث بن سکتا ہے۔",
            image_hd: Images.urdu11_hd,
            image: Images.urdu11_ld,
        }, {
            title: "اپنی جنگ اکیلے مت لڑو",
            image_hd: Images.urdu12_hd,
            image: Images.urdu12_ld,
        }, {
            title: "خیر و عافیت کے فوائد",
            image_hd: Images.urdu13_hd,
            image: Images.urdu13_ld,
        }, {
            title: "تنازعات کے حل کی تکنیک",
            image_hd: Images.urdu15_hd,
            image: Images.urdu15_ld,
        }, {
            title: "مثبت سوچ",
            image_hd: Images.urdu16_hd,
            image: Images.urdu16_ld,
        }, {
            title: "دماغی صحت کے لیے محفوظ جگہ کیسے بنائیں",
            image_hd: Images.urdu17_hd,
            image: Images.urdu17_ld,
        }, {
            title: "تناؤ کا جواب دینا",
            image_hd: Images.urdu18_hd,
            image: Images.urdu18_ld,
        }, {
            title: "تناؤ کو کم کرنے کے لیے سانس لینے کی تکنیک",
            image_hd: Images.urdu19_hd,
            image: Images.urdu19_ld,
        }, {
            title: "اپنے بہترین نفس کو حاصل کریں",
            image_hd: Images.urdu20_hd,
            image: Images.urdu20_ld,
        }, {
            title: "تنازعات کے حل کی مہارتیں",
            image_hd: Images.urdu21_hd,
            image: Images.urdu21_ld,
        }, {
            title: "ذیابیطس",
            image_hd: Images.urdu22_hd,
            image: Images.urdu22_ld,
        }, {
            title: "علامات کو جانیں",
            image_hd: Images.urdu23_hd,
            image: Images.urdu23_ld,
        }, {
            title: "لڑو یا بھاگو کیا ہے؟",
            image_hd: Images.urdu24_hd,
            image: Images.urdu24_ld,
        }, {
            title: "تھراپی کیسے مدد کرتی ہے؟",
            image_hd: Images.urdu25_hd,
            image: Images.urdu25_ld,
        }, {
            title: "نیند کا انتظام",
            image_hd: Images.urdu26_hd,
            image: Images.urdu26_ld,
        }, {
            title: "ورکرز کی فلاح و بہبود کا پروگرام",
            image_hd: Images.urdu27_hd,
            image: Images.urdu27_ld,
        }, {
            title: "فائدہ مند ترکیبیں دماغی صحت کے لیے",
            image_hd: Images.urdu28_hd,
            image: Images.urdu28_ld,
        }, {
            title: "PTSD کیا ہے؟",
            image_hd: Images.urdu29_hd,
            image: Images.urdu29_ld,
        }, {
            title: "کنٹریکٹر کی فالح و بہبود پروگرام",
            image_hd: Images.urdu30_hd,
            image: Images.urdu30_ld,
        }, {
            title: "ترقی کی سوچ",
            image_hd: Images.urdu31_hd,
            image: Images.urdu31_ld,
        }, {
            title: "ذیابیطس کی علامات",
            image_hd: Images.urdu32_hd,
            image: Images.urdu32_ld,
        }, {
            title: "ایک مسئلہ شیئر کرنے سے مسئلہ آدھا ہو جاتا ہے",
            image_hd: Images.urdu33_hd,
            image: Images.urdu33_ld,
        },
        {
            title: "سوال پوچھیں، ایک زندگی بچائیں",
            image_hd: Images.urdu34_hd,
            image: Images.urdu34_ld,
        },
        {
            title: "ٹوٹا ہوا دل",
            image_hd: Images.urdu35_hd,
            image: Images.urdu35_ld,
        },
        {
            title: "عام غلط فہمی",
            image_hd: Images.urdu36_hd,
            image: Images.urdu36_ld,
        },
        {
            title: "کنٹریکٹر پاسپورٹ والیٹ کارڈ مینجمنٹ کے لیے",
            image_hd: Images.urdu37_hd,
            image: Images.urdu37_ld,
        },
        {
            title: "کنٹریکٹر-پاسپورٹ پوسٹر صارفین کے لیے",
            image_hd: Images.urdu38_hd,
            image: Images.urdu38_ld,
        },
        {
            title: "کنٹریکٹر-پاسپورٹ والیٹ-کارڈ صارفین کے لیے",
            image_hd: Images.urdu39_hd,
            image: Images.urdu39_ld,
        },
        {
            title: "صحت مند اسنیکس",
            image_hd: Images.urdu40_hd,
            image: Images.urdu40_ld,
        },
        {
            title: "مینجمنٹ کنٹریکٹر-پاسپورٹ پوسٹر",
            image_hd: Images.urdu41_hd,
            image: Images.urdu41_ld,
        },
        {
            title: "WHO-5 پوسٹر",
            image_hd: Images.urdu42_hd,
            image: Images.urdu42_ld,
        },
        {
            title: "QPR پوسٹر (QR کوڈز کے ساتھ)",
            image_hd: Images.urdu43_hd,
            image: Images.urdu43_ld,
        },
        {
            title: "اسٹریس کی علامات آرامکو پوسٹر",
            image_hd: Images.urdu44_hd,
            image: Images.urdu44_ld,
        },
        {
            title: "ڈی ہائیڈریشن سے بچاؤ کے لیے ٹپس",
            image_hd: Images.urdu45_hd,
            image: Images.urdu45_ld,
        },
        {
            title: "حوصلہ افزا قول ۱",
            image_hd: Images.urdu46_hd,
            image: Images.urdu46_ld,
        },
        {
            title: "حوصلہ افزا قول ۳",
            image_hd: Images.urdu47_hd,
            image: Images.urdu47_ld,
        },
        {
            title: "ہمارا سروس کب استعمال کریں",
            image_hd: Images.urdu48_hd,
            image: Images.urdu48_ld,
        },
        {
            title: "WHO-5 اسٹیکر",
            image_hd: Images.urdu49_hd,
            image: Images.urdu49_ld,
        },
        {
            title: "برن آؤٹ کو کم کریں",
            image_hd: Images.urdu50_hd,
            image: Images.urdu50_ld,
        },
        {
            title: "ذہنی صحت مہارت مینیجرز",
            image_hd: Images.urdu51_hd,
            image: Images.urdu51_ld,
        },
        {
            title: "کمیونٹی کے اقدار کی حمایت",
            image_hd: Images.urdu52_hd,
            image: Images.urdu52_ld,
        },
        {
            title: "پانی کی کمی کی روک تھام",
            image_hd: Images.urdu53_hd,
            image: Images.urdu53_ld,
        },
        {
            title: "گھبراہٹ کے دورے",
            image_hd: Images.urdu54_hd,
            image: Images.urdu54_ld,
        },
        {
            title: "حد سے زیادہ سوچنا",
            image_hd: Images.urdu55_hd,
            image: Images.urdu55_ld,
        },
        {
            title: "مشکل گفتگو کے لیے ایک انتظامی مہارت-جذباتی ذہانت",
            image_hd: Images.urdu56_hd,
            image: Images.urdu56_ld,
        },
        {
            title: "تناؤ کی علامات کی شناخت",
            image_hd: Images.urdu57_hd,
            image: Images.urdu57_ld,
        },
        {
            title: "عادتوں کو سمجھنا",
            image_hd: Images.urdu58_hd,
            image: Images.urdu58_ld,
        },
        {
            title: "مالی فلاح و بہبود",
            image_hd: Images.urdu59_hd,
            image: Images.urdu59_ld,
        },
        {
            title: "ایکسپیٹ کی فلاح",
            image_hd: Images.urdu60_hd,
            image: Images.urdu60_ld,
        },

        {
            title: "ذہنی ہوشیاری",
            image_hd: Images.urdu61_hd,
            image: Images.urdu61_ld,
        },
        {
            title: "گرمی کا دباؤ",
            image_hd: Images.urdu62_hd,
            image: Images.urdu62_ld,
        },
        {
            title: "کام پر تھکاوٹ محسوس ہو رہی ہے؟",
            image_hd: Images.urdu63_hd,
            image: Images.urdu63_ld,
        },
        {
            title: "گرمیوں میں محفوظ رہنے کے لیے رہنمائی",
            image_hd: Images.urdu64_hd,
            image: Images.urdu64_ld,
        },
        {
            title: "دانتوں کی صفائی",
            image_hd: Images.urdu65_hd,
            image: Images.urdu65_ld,
        },
        {
            title: "فیملی کے ساتھ آن لائن بات چیت کرنا",
            image_hd: Images.urdu66_hd,
            image: Images.urdu66_ld,
        },
        {
            title: "اپنا اعتماد پیدا کریں",
            image_hd: Images.urdu67_hd,
            image: Images.urdu67_ld,
        },
        {
            title: "کونٹریکٹر کی فلاح و بہبود",
            image_hd: Images.urdu68_hd,
            image: Images.urdu68_ld,
        },
        {
            title: "جسمانی صحت میں تناؤ",
            image_hd: Images.urdu69_hd,
            image: Images.urdu69_ld,
        },
    ],
    arabic: [
        {
            title: 'التعرف على علامات المنذرة',
            image_hd: Images.arabic1_hd,
            image: Images.arabic1_ld,
        }, {
            title: 'التعامل مع الضغوطات',
            image_hd: Images.arabic2_hd,
            image: Images.arabic2_ld,
        }, {
            title: 'التعامل مع الحزن',
            image_hd: Images.arabic3_hd,
            image: Images.arabic3_ld,
        }, {
            title: 'أنت لست وحدك',
            image_hd: Images.arabic4_hd,
            image: Images.arabic4_ld,
        }, {
            title: 'أنت لست وحدك',
            image_hd: Images.arabic5_hd,
            image: Images.arabic5_ld,
        }, {
            title: 'هل تشعر بالإ حباط؟',
            image_hd: Images.arabic6_hd,
            image: Images.arabic6_ld,
        }, {
            title: ' لیس علیك خوض معرکتك لوحدك',
            image_hd: Images.arabic8_hd,
            image: Images.arabic8_ld,
        }, {
            title: " قلة النوم ممکن ان تسبب",
            image_hd: Images.arabic10_hd,
            image: Images.arabic10_ld,
        }, {
            title: "يمكن أن يؤدي نقص الدعم الاجتماعي إلی",
            image_hd: Images.arabic11_hd,
            image: Images.arabic11_ld,
        }, {
            title: "لا تقاتل معركتك وحدك",
            image_hd: Images.arabic12_hd,
            image: Images.arabic12_ld,
        }, {
            title: "فوائد العافية",
            image_hd: Images.arabic13_hd,
            image: Images.arabic13_ld,
        }, {
            title: "التعامل مع التواتر النفسی",
            image_hd: Images.arabic14_hd,
            image: Images.arabic14_ld,
        }, {
            title: "اضطراب ما بعد الصدمة",
            image_hd: Images.arabic15_hd,
            image: Images.arabic15_ld,
        }, {
            title: "التفکیر الایجابی",
            image_hd: Images.arabic16_hd,
            image: Images.arabic16_ld,
        }, {
            title: "برنامج العافیة للمتعاقدین",
            image_hd: Images.arabic17_hd,
            image: Images.arabic17_ld,
        }, {
            title: "تقنیات حل النزاع",
            image_hd: Images.arabic18_hd,
            image: Images.arabic18_ld,
        }, {
            title: "مرض السکری",
            image_hd: Images.arabic19_hd,
            image: Images.arabic19_ld,
        }, {
            title: "عقلیة النمو",
            image_hd: Images.arabic20_hd,
            image: Images.arabic20_ld,
        }, {
            title: "كيف بإمكانك تهيئة مساحة أمنة للتحدث عن الصحة النفسية",
            image_hd: Images.arabic21_hd,
            image: Images.arabic21_ld,
        }, {
            title: "أعراض مرض السكري",
            image_hd: Images.arabic22_hd,
            image: Images.arabic22_ld,
        }, {
            title: "نصائح للمحافظة على الصحة النفسية",
            image_hd: Images.arabic23_hd,
            image: Images.arabic23_ld,
        }, {
            title: "أساليب تقليل التوتر عبر التنفس العميق",
            image_hd: Images.arabic24_hd,
            image: Images.arabic24_ld,
        }, {
            title: "يمكنك أن تكون في أفضل حال",
            image_hd: Images.arabic25_hd,
            image: Images.arabic25_ld,
        }, {
            title: "مهارات حل النزاع",
            image_hd: Images.arabic26_hd,
            image: Images.arabic26_ld,
        }, {
            title: "برنامج عافية المقاول",
            image_hd: Images.arabic27_hd,
            image: Images.arabic27_ld,
        }, {
            title: "تعرف على الأعراض",
            image_hd: Images.arabic28_hd,
            image: Images.arabic28_ld,
        }, {
            title: "ما هى استجابة الكر أو الفر؟",
            image_hd: Images.arabic29_hd,
            image: Images.arabic29_ld,
        }, {
            title: "كيف سيساعدك العلاج النفسي",
            image_hd: Images.arabic30_hd,
            image: Images.arabic30_ld,
        }, {
            title: "تنظیم النوم",
            image_hd: Images.arabic31_hd,
            image: Images.arabic31_ld,
        }, {
            title: "المشكلة التي تُشارك تُصبح نصف مشكلة",
            image_hd: Images.arabic32_hd,
            image: Images.arabic32_ld,
        }, {
            title: "اسأل سؤالاً، تنقذ حياة",
            image_hd: Images.arabic33_hd,
            image: Images.arabic33_ld,
        }, {
            title: "قلب مكسور",
            image_hd: Images.arabic34_hd,
            image: Images.arabic34_ld,
        }, {
            title: "مفهوم خاطئ شائع",
            image_hd: Images.arabic35_hd,
            image: Images.arabic35_ld,
        }, {
            title: "بطاقة جواز السفر للمقاول إلى الإدارة",
            image_hd: Images.arabic36_hd,
            image: Images.arabic36_ld,
        }, {
            title: "ملصق جواز السفر للمقاول للمستخدمين",
            image_hd: Images.arabic37_hd,
            image: Images.arabic37_ld,
        }, {
            title: "بطاقة جواز السفر للمقاول للمستخدمين",
            image_hd: Images.arabic38_hd,
            image: Images.arabic38_ld,
        }, {
            title: "وجبات خفيفة صحية",
            image_hd: Images.arabic39_hd,
            image: Images.arabic39_ld,
        }, {
            title: "ملصق جواز سفر المقاول للإدارة",
            image_hd: Images.arabic40_hd,
            image: Images.arabic40_ld,
        }, {
            title: "ملصق لمنظمة الصحة العالمية-5",
            image_hd: Images.arabic41_hd,
            image: Images.arabic41_ld,
        }, {
            title: "ملصق QPR (مع رموز QR)",
            image_hd: Images.arabic42_hd,
            image: Images.arabic42_ld,
        }, {
            title: "علامات التوتر أرامكو",
            image_hd: Images.arabic43_hd,
            image: Images.arabic43_ld,
        }, {
            title: "نصائح للمساعدة في منع الجفاف",
            image_hd: Images.arabic44_hd,
            image: Images.arabic44_ld,
        }, {
            title: "مثل مرفّع 1",
            image_hd: Images.arabic45_hd,
            image: Images.arabic45_ld,
        }, {
            title: "مثل مرفّع 3",
            image_hd: Images.arabic46_hd,
            image: Images.arabic46_ld,
        }, {
            title: "متى يجب استخدام خدمتنا",
            image_hd: Images.arabic47_hd,
            image: Images.arabic47_ld,
        }, {
            title: "ملصق WHO-5",
            image_hd: Images.arabic48_hd,
            image: Images.arabic48_ld,
        }, {
            title: "تقليل الإرهاق",
            image_hd: Images.arabic49_hd,
            image: Images.arabic49_ld,
        }, {
            title: "مدير مهارات الصحة النفسية",
            image_hd: Images.arabic50_hd,
            image: Images.arabic50_ld,
        }, {
            title: "الوقاية من الجفاف",
            image_hd: Images.arabic51_hd,
            image: Images.arabic51_ld,
        },
        {
            title: "دعم قيم المجتمع",
            image_hd: Images.arabic52_hd,
            image: Images.arabic52_ld,
        },
        {
            title: "نوبات الهلع",
            image_hd: Images.arabic53_hd,
            image: Images.arabic53_ld,
        },
        {
            title: "الذكاء العاطفي- مهارة إدارية للمحادثات الصعبة",
            image_hd: Images.arabic54_hd,
            image: Images.arabic54_ld,
        },
        {
            title: "الإفراط في التفكير",
            image_hd: Images.arabic55_hd,
            image: Images.arabic55_ld,
        },
        {
            title: "تعرف على علامات التوتر",
            image_hd: Images.arabic56_hd,
            image: Images.arabic56_ld,
        },
        {
            title: "فَهم العادات",
            image_hd: Images.arabic57_hd,
            image: Images.arabic57_ld,
        },
        {
            title: "الر فاهية المالي",
            image_hd: Images.arabic58_hd,
            image: Images.arabic58_ld,
        },
        {
            title: "رفاهية المغتربين",
            image_hd: Images.arabic59_hd,
            image: Images.arabic59_ld,
        },
        {
            title: "دليل البقاء على قيد الحياة في الصيف",
            image_hd: Images.arabic60_hd,
            image: Images.arabic60_ld,
        },
        {
            title: "الوعي التام",
            image_hd: Images.arabic61_hd,
            image: Images.arabic61_ld,
        },
        {
            title: "هل تشعر بالإرهاق في العمل؟",
            image_hd: Images.arabic62_hd,
            image: Images.arabic62_ld,
        },
        {
            title: "الإجهاد الحراري",
            image_hd: Images.arabic63_hd,
            image: Images.arabic63_ld,
        },
        {
            title: "نظافة الأسنان",
            image_hd: Images.arabic64_hd,
            image: Images.arabic64_ld,
        },
        {
            title: "التواصل عبر الإنترنت مع العائلة",
            image_hd: Images.arabic65_hd,
            image: Images.arabic65_ld,
        },
        {
            title: "ابنِ ثقتك بنفسك",
            image_hd: Images.arabic66_hd,
            image: Images.arabic66_ld,
        },
        {
            title: "رفاهية المقاول",
            image_hd: Images.arabic67_hd,
            image: Images.arabic67_ld,
        },
        {
            title: "التوتر في الصحة الجسدية",
            image_hd: Images.arabic68_hd,
            image: Images.arabic68_ld,
        },

    ],
    bangali: [
        {
            title: 'সতর্কতা চিহ্ন সনাক্তকরণ',
            image_hd: Images.bangali1_hd,
            image: Images.bangali1_ld,
        }, {
            title: 'স্ট্রেস ব্যবস্থাপনা',
            image_hd: Images.bangali2_hd,
            image: Images.bangali2_ld,
        }, {
            title: 'দুঃখ ব্যবস্থাপনা',
            image_hd: Images.bangali3_hd,
            image: Images.bangali3_ld,
        }, {
            title: 'তুমি একা নও',
            image_hd: Images.bangali4_hd,
            image: Images.bangali4_ld,
        }, {
            title: 'তুমি একা নও',
            image_hd: Images.bangali5_hd,
            image: Images.bangali5_ld,
        }, {
            title: 'নিচের অনুভূতি?',
            image_hd: Images.bangali6_hd,
            image: Images.bangali6_ld,
        }, {
            title: 'সাহায্যের জন্য জিজ্ঞাসা করা ঠিক আছে',
            image_hd: Images.bangali8_hd,
            image: Images.bangali8_ld,
        }, {
            title: "ঘুমের অভাবের কারণ কী হতে পারে?",
            image_hd: Images.bangali10_hd,
            image: Images.bangali10_ld,
        }, {
            title: "সামাজিক সমর্থনের অভাব হতে পারে।",
            image_hd: Images.bangali11_hd,
            image: Images.bangali11_ld,
        }, {
            title: "একা একা যুদ্ধ করবেন না",
            image_hd: Images.bangali12_hd,
            image: Images.bangali12_ld,
        }, {
            title: "সুস্থতার সুবিধা",
            image_hd: Images.bangali13_hd,
            image: Images.bangali13_ld,
        }, {
            title: "স্ট্রেস এর প্রতিক্রিয়া",
            image_hd: Images.bangali14_hd,
            image: Images.bangali14_ld,
        }, {
            title: "উদ্বেগ মানসিকতা",
            image_hd: Images.bangali15_hd,
            image: Images.bangali15_ld,
        }, {
            title: "ডায়াবেটিস",
            image_hd: Images.bangali16_hd,
            image: Images.bangali16_ld,
        }, {
            title: "কম্বাইন্ড কল্যাণ কর্মসূচি",
            image_hd: Images.bangali17_hd,
            image: Images.bangali17_ld,
        }, {
            title: "4 ধরনের PTSD উপসর্গ:",
            image_hd: Images.bangali18_hd,
            image: Images.bangali18_ld,
        }, {
            title: "ইতিবাচক চিন্তা",
            image_hd: Images.bangali19_hd,
            image: Images.bangali19_ld,
        }, {
            title: "দ্রুত সমাধানের কৌশল",
            image_hd: Images.bangali20_hd,
            image: Images.bangali20_ld,
        }, {
            title: "সুস্থতা কর্মসূচীর সংগঠন",
            image_hd: Images.bangali22_hd,
            image: Images.bangali22_ld,
        }, {
            title: "ডায়াবেটিস লক্ষণ",
            image_hd: Images.bangali23_hd,
            image: Images.bangali23_ld,
        }, {
            title: "বজায় রাখার জন্য পরামর্শ মানসিক স্বাস্থ্য",
            image_hd: Images.bangali24_hd,
            image: Images.bangali24_ld,
        }, {
            title: "স্ট্রেস কমাতে শ্বাস প্রশ্বাসের কৌশল",
            image_hd: Images.bangali25_hd,
            image: Images.bangali25_ld,
        }, {
            title: "নিজের মধ্যে সেরা অর্জনের কথা ভাবুন",
            image_hd: Images.bangali26_hd,
            image: Images.bangali26_ld,
        }, {
            title: "দ্বন্দ্ব সমাধানের দক্ষতা",
            image_hd: Images.bangali27_hd,
            image: Images.bangali27_ld,
        }, {
            title: "লক্ষণগুলি জানুন",
            image_hd: Images.bangali28_hd,
            image: Images.bangali28_ld,
        }, {
            title: "ফাইট অর ফ্লাইট কী?",
            image_hd: Images.bangali29_hd,
            image: Images.bangali29_ld,
        }, {
            title: "কিভাবে থেরাপি সাহায্য করে",
            image_hd: Images.bangali30_hd,
            image: Images.bangali30_ld,
        }, {
            title: "ঘুম ব্যবস্থাপনা",
            image_hd: Images.bangali31_hd,
            image: Images.bangali31_ld,
        }, {
            title: "দলগুলোর সুস্থতা কীভাবে সহায়তা করবেন",
            image_hd: Images.bangali32_hd,
            image: Images.bangali32_ld,
        }, {
            title: "একটি সমস্যা ভাগ করলে সমস্যা অর্ধেক হয়ে যায়",
            image_hd: Images.bangali33_hd,
            image: Images.bangali33_ld,
        },
        {
            title: "প্রশ্ন করুন, একটি জীবন বাঁচান",
            image_hd: Images.bangali34_hd,
            image: Images.bangali34_ld,
        },
        {
            title: "ভাঙ্গা হৃদয়",
            image_hd: Images.bangali35_hd,
            image: Images.bangali35_ld,
        },
        {
            title: "সাধারণ ভুল ধারণা",
            image_hd: Images.bangali36_hd,
            image: Images.bangali36_ld,
        },
        {
            title: "কন্ট্রাক্টর পাসপোর্ট ওয়ালেট কার্ড ম্যানেজমেন্টের জন্য",
            image_hd: Images.bangali37_hd,
            image: Images.bangali37_ld,
        },
        {
            title: "কন্ট্রাক্টর-পাসপোর্ট পোস্টার ব্যবহারকারীদের জন্য",
            image_hd: Images.bangali38_hd,
            image: Images.bangali38_ld,
        },
        {
            title: "কন্ট্রাক্টর-পাসপোর্ট ওয়ালেট-কার্ড ব্যবহারকারীদের জন্য",
            image_hd: Images.bangali39_hd,
            image: Images.bangali39_ld,
        },
        {
            title: "স্বাস্থ্যকর স্ন্যাকস",
            image_hd: Images.bangali40_hd,
            image: Images.bangali40_ld,
        },
        {
            title: "ম্যানেজমেন্ট কন্ট্রাক্টর-পাসপোর্ট পোস্টার",
            image_hd: Images.bangali41_hd,
            image: Images.bangali41_ld,
        },
        {
            title: "WHO-5 পোস্টার",
            image_hd: Images.bangali42_hd,
            image: Images.bangali42_ld,
        },
        {
            title: "QPR পোস্টার (QR কোড সহ)",
            image_hd: Images.bangali43_hd,
            image: Images.bangali43_ld,
        },
        {
            title: "স্ট্রেসের লক্ষণ আরামকো পোস্টার",
            image_hd: Images.bangali44_hd,
            image: Images.bangali44_ld,
        },
        {
            title: "ডিহাইড্রেশন প্রতিরোধে সহায়ক টিপস",
            image_hd: Images.bangali45_hd,
            image: Images.bangali45_ld,
        },
        {
            title: "উত্সাহজনক প্রবাদ ১",
            image_hd: Images.bangali46_hd,
            image: Images.bangali46_ld,
        },
        {
            title: "উত্সাহজনক প্রবাদ ৩",
            image_hd: Images.bangali47_hd,
            image: Images.bangali47_ld,
        },
        {
            title: "আমাদের সেবা কখন ব্যবহার করবেন",
            image_hd: Images.bangali48_hd,
            image: Images.bangali48_ld,
        },
        {
            title: "WHO-5 স্টিকার",
            image_hd: Images.bangali49_hd,
            image: Images.bangali49_ld,
        },
        {
            title: "বার্নআউট কমান",
            image_hd: Images.bangali50_hd,
            image: Images.bangali50_ld,
        },
        {
            title: "কমিউনিটি মূল্যসমূহের সমর্থন",
            image_hd: Images.bangali51_hd,
            image: Images.bangali51_ld,
        },
        {
            title: "পানির অভাব প্রতিরোধ",
            image_hd: Images.bangali52_hd,
            image: Images.bangali52_ld,
        },
        {
            title: "মানসিক স্বাস্থ্য দক্ষতা ব্যবস্থাপক",
            image_hd: Images.bangali53_hd,
            image: Images.bangali53_ld,
        },
        {
            title: "আবে গি ক বুদ্ধিবুদ্ধিমত্তা-কঠিন কথো পকথনে র জন্য একটি ব্য বস্থা পনা দক্ষতা",
            image_hd: Images.bangali54_hd,
            image: Images.bangali54_ld,
        },
        {
            title: "তিরিক্ত চিন্তা ভাবনা",
            image_hd: Images.bangali55_hd,
            image: Images.bangali55_ld,
        },
        {
            title: "আতঙ্কের আক্রমণ",
            image_hd: Images.bangali56_hd,
            image: Images.bangali56_ld,
        },
        {
            title: "চাপের লক্ষণ শনাক্তকরণ",
            image_hd: Images.bangali57_hd,
            image: Images.bangali57_ld,
        },

        {
            title: "অভাস বাঝা",
            image_hd: Images.bangali58_hd,
            image: Images.bangali58_ld,
        },
        {
            title: "আর্থিক সুস্থতা",
            image_hd: Images.bangali59_hd,
            image: Images.bangali59_ld,
        },
        {
            title: "প্রবাসীদের কল্যাণ",
            image_hd: Images.bangali60_hd,
            image: Images.bangali60_ld,
        },
        {
            title: "মাইন্ডফুলনেস",
            image_hd: Images.bangali61_hd,
            image: Images.bangali61_ld,
        },
        {
            title: "তাপের চাপ",
            image_hd: Images.bangali62_hd,
            image: Images.bangali62_ld,
        },
        {
            title: "কর্মক্ষেত্রে ক্লান্ত লাগছে?",
            image_hd: Images.bangali63_hd,
            image: Images.bangali63_ld,
        },
        {
            title: "গ্রীষ্মকালীন টিকে থাকার নির্দেশিকা",
            image_hd: Images.bangali64_hd,
            image: Images.bangali64_ld,
        },
        {
            title: "দাঁতের পরিষ্কার-পরিচ্ছন্নতা",
            image_hd: Images.bangali65_hd,
            image: Images.bangali65_ld,
        },
        {
            title: "পরিবারের সঙ্গে অনলাইনে যোগাযোগ",
            image_hd: Images.bangali66_hd,
            image: Images.bangali66_ld,
        },
        {
            title: "আপনার আত্মবিশ্বাস গড়ে তুলুন",
            image_hd: Images.bangali67_hd,
            image: Images.bangali67_ld,
        },
        {
            title: "কন্ট্রাক্টরের কল্যাণ",
            image_hd: Images.bangali68_hd,
            image: Images.bangali68_ld,
        },
        {
            title: "শারীরিক স্বাস্থ্যে চাপ",
            image_hd: Images.bangali69_hd,
            image: Images.bangali69_ld,
        },
    ],
    chinese: [
        {
            title: '识别警告标志',
            image_hd: Images.chinese1_hd,
            image: Images.chinese1_ld,
        }, {
            title: '管理压力',
            image_hd: Images.chinese2_hd,
            image: Images.chinese2_ld,
        }, {
            title: '管理悲伤',
            image_hd: Images.chinese3_hd,
            image: Images.chinese3_ld,
        }, {
            title: '你并不孤单',
            image_hd: Images.chinese4_hd,
            image: Images.chinese4_ld,
        }, {
            title: '你并不孤单',
            image_hd: Images.chinese5_hd,
            image: Images.chinese5_ld,
        }, {
            title: '情绪低落？',
            image_hd: Images.chinese6_hd,
            image: Images.chinese6_ld,
        }, {
            title: '积极的情绪',
            image_hd: Images.chinese_positive_emotions_1_hd,
            image: Images.chinese_positive_emotions_1_ld,
        }, {
            title: '积极的情绪',
            image_hd: Images.chinese_positive_emotions_2_hd,
            image: Images.chinese_positive_emotions_2_ld,
        }, {
            title: '可以寻求帮助',
            image_hd: Images.chinese8_hd,
            image: Images.chinese8_ld,
        }, {
            title: "睡眠不足的原因可能是什么？",
            image_hd: Images.chinese10_hd,
            image: Images.chinese10_ld,
        }, {
            title: "缺乏社会支持会导致。",
            image_hd: Images.chinese11_hd,
            image: Images.chinese11_ld,
        }, {
            title: "不要孤军奋战",
            image_hd: Images.chinese12_hd,
            image: Images.chinese12_ld,
        }, {
            title: "福祉的好处",
            image_hd: Images.chinese13_hd,
            image: Images.chinese13_ld,
        }, {
            title: "承包商福利计划",
            image_hd: Images.chinese14_hd,
            image: Images.chinese14_ld,
        }, {
            title: "解决冲突的技巧",
            image_hd: Images.chinese15_hd,
            image: Images.chinese15_ld,
        }, {
            title: "糖尿病",
            image_hd: Images.chinese16_hd,
            image: Images.chinese16_ld,
        }, {
            title: "积极的思考",
            image_hd: Images.chinese17_hd,
            image: Images.chinese17_ld,
        }, {
            title: "成长型思维",
            image_hd: Images.chinese18_hd,
            image: Images.chinese18_ld,
        }, {
            title: "创伤后应激障碍的4种症状",
            image_hd: Images.chinese19_hd,
            image: Images.chinese19_ld,
        }, {
            title: "应对压力",
            image_hd: Images.chinese20_hd,
            image: Images.chinese20_ld,
        }, {
            title: "创建心理健康的安全空间",
            image_hd: Images.chinese21_hd,
            image: Images.chinese21_ld
        }, {
            title: "缓解压力的呼吸技巧",
            image_hd: Images.chinese22_hd,
            image: Images.chinese22_ld
        }, {
            title: "做最好的自己",
            image_hd: Images.chinese23_hd,
            image: Images.chinese23_ld
        }, {
            title: "解决冲突的技巧",
            image_hd: Images.chinese24_hd,
            image: Images.chinese24_ld
        }, {
            title: "承包商福利计划",
            image_hd: Images.chinese25_hd,
            image: Images.chinese25_ld
        }, {
            title: "糖尿病 症状",
            image_hd: Images.chinese26_hd,
            image: Images.chinese26_ld
        }, {
            title: "了解症状",
            image_hd: Images.chinese27_hd,
            image: Images.chinese27_ld
        }, {
            title: "什么是‘战斗或逃跑’反应?",
            image_hd: Images.chinese28_hd,
            image: Images.chinese28_ld
        }, {
            title: "治疗如何帮助",
            image_hd: Images.chinese29_hd,
            image: Images.chinese29_ld
        }, {
            title: "保持心理健康的小贴士",
            image_hd: Images.chinese30_hd,
            image: Images.chinese30_ld
        }, {
            title: "睡眠管理",
            image_hd: Images.chinese31_hd,
            image: Images.chinese31_ld
        }, {
            title: "问题共享，问题减半",
            image_hd: Images.chinese32_hd,
            image: Images.chinese32_ld
        },
        {
            title: "提出问题，拯救生命",
            image_hd: Images.chinese33_hd,
            image: Images.chinese33_ld
        },
        {
            title: "伤心",
            image_hd: Images.chinese34_hd,
            image: Images.chinese34_ld
        },
        {
            title: "常见误解",
            image_hd: Images.chinese35_hd,
            image: Images.chinese35_ld
        },
        {
            title: "承包商护照钱包卡到管理层",
            image_hd: Images.chinese36_hd,
            image: Images.chinese36_ld
        },
        {
            title: "承包商护照用户海报",
            image_hd: Images.chinese37_hd,
            image: Images.chinese37_ld
        },
        {
            title: "承包商护照钱包卡用户版",
            image_hd: Images.chinese38_hd,
            image: Images.chinese38_ld
        },
        {
            title: "健康小吃",
            image_hd: Images.chinese39_hd,
            image: Images.chinese39_ld
        },
        {
            title: "管理层承包商护照海报",
            image_hd: Images.chinese40_hd,
            image: Images.chinese40_ld
        },
        {
            title: "WHO-5海报",
            image_hd: Images.chinese41_hd,
            image: Images.chinese41_ld
        },
        {
            title: "带有二维码的QPR海报",
            image_hd: Images.chinese42_hd,
            image: Images.chinese42_ld
        },
        {
            title: "阿美石油公司压力迹象海报",
            image_hd: Images.chinese43_hd,
            image: Images.chinese43_ld
        },
        {
            title: "预防脱水的提示",
            image_hd: Images.chinese44_hd,
            image: Images.chinese44_ld
        },
        {
            title: "鼓舞人心的格言1",
            image_hd: Images.chinese45_hd,
            image: Images.chinese45_ld
        },
        {
            title: "鼓舞人心的格言3",
            image_hd: Images.chinese46_hd,
            image: Images.chinese46_ld
        },
        {
            title: "何时使用我们的服务",
            image_hd: Images.chinese47_hd,
            image: Images.chinese47_ld
        },
        {
            title: "WHO-5贴纸",
            image_hd: Images.chinese48_hd,
            image: Images.chinese48_ld
        },
        {
            title: "减少职业倦怠",
            image_hd: Images.chinese49_hd,
            image: Images.chinese49_ld
        },
        {
            title: "预防脱水",
            image_hd: Images.chinese50_hd,
            image: Images.chinese50_ld
        },
        {
            title: "心理健康技能经理",
            image_hd: Images.chinese51_hd,
            image: Images.chinese51_ld
        },
        {
            title: "社区价值支持",
            image_hd: Images.chinese52_hd,
            image: Images.chinese52_ld
        },
        {
            title: "惊恐发作",
            image_hd: Images.chinese53_hd,
            image: Images.chinese53_ld
        },
        {
            title: "应对艰难对话的管理技能——情绪智能",
            image_hd: Images.chinese54_hd,
            image: Images.chinese54_ld
        },
        {
            title: "过度思考",
            image_hd: Images.chinese55_hd,
            image: Images.chinese55_ld
        },
        {
            title: "識別壓力跡象",
            image_hd: Images.chinese56_hd,
            image: Images.chinese56_ld
        },
        {
            title: "了解习惯",
            image_hd: Images.chinese57_hd,
            image: Images.chinese57_ld
        },
        {
            title: "财务健康与福祉",
            image_hd: Images.chinese58_hd,
            image: Images.chinese58_ld
        },

        {
            title: "外籍人士的福祉",
            image_hd: Images.chinese59_hd,
            image: Images.chinese59_ld
        },
        {
            title: "正念",
            image_hd: Images.chinese60_hd,
            image: Images.chinese60_ld
        },
        {
            title: "热应激",
            image_hd: Images.chinese61_hd,
            image: Images.chinese61_ld
        },
        {
            title: "工作时感到筋疲力尽吗?",
            image_hd: Images.chinese62_hd,
            image: Images.chinese62_ld
        },
        {
            title: "夏季生存指南",
            image_hd: Images.chinese63_hd,
            image: Images.chinese63_ld
        },
        {
            title: "口腔卫生",
            image_hd: Images.chinese64_hd,
            image: Images.chinese64_ld
        },
        {
            title: "与家人在线沟通",
            image_hd: Images.chinese65_hd,
            image: Images.chinese65_ld
        },
        {
            title: "建立自信",
            image_hd: Images.chinese66_hd,
            image: Images.chinese66_ld
        },
        {
            title: "承包商的福祉",
            image_hd: Images.chinese67_hd,
            image: Images.chinese67_ld
        },
        {
            title: "身体健康中的压力",
            image_hd: Images.chinese68_hd,
            image: Images.chinese68_ld
        },
    ],
    hindi: [
        {
            title: 'चेतावनी के संकेतों को पहचानना',
            image_hd: Images.hindi1_hd,
            image: Images.hindi1_ld,
        }, {
            title: 'प्रबंधन तनाव',
            image_hd: Images.hindi2_hd,
            image: Images.hindi2_ld,
        }, {
            title: 'दुख का प्रबंधन',
            image_hd: Images.hindi3_hd,
            image: Images.hindi3_ld,
        }, {
            title: 'तुम अकेले नही हो',
            image_hd: Images.hindi4_hd,
            image: Images.hindi4_ld,
        }, {
            title: 'तुम अकेले नही हो',
            image_hd: Images.hindi5_hd,
            image: Images.hindi5_ld,
        }, {
            title: 'बुरा महसूस करना?',
            image_hd: Images.hindi6_hd,
            image: Images.hindi6_ld,
        }, {
            title: 'ठेकेदार कल्याण कार्यक्रम',
            image_hd: Images.hindi7_hd,
            image: Images.hindi7_ld,
        }, {
            title: 'मदद मांगना ठीक है',
            image_hd: Images.hindi8_hd,
            image: Images.hindi8_ld,
        }, {
            title: "नींद पूरी न होने का क्या कारण हो सकता है?",
            image_hd: Images.hindi10_hd,
            image: Images.hindi10_ld,
        }, {
            title: "सामाजिक समर्थन की कमी हो सकती है।",
            image_hd: Images.hindi11_hd,
            image: Images.hindi11_ld,
        }, {
            title: "अपनी लड़ाई अकेले मत लड़ो",
            image_hd: Images.hindi12_hd,
            image: Images.hindi12_ld,
        }, {
            title: "भलाई के लाभ",
            image_hd: Images.hindi13_hd,
            image: Images.hindi13_ld,
        }, {
            title: "पीटीएसडी के 4 प्रकार के लक्षण",
            image_hd: Images.hindi14_hd,
            image: Images.hindi14_ld,
        }, {
            title: "ठेकेदार कल्याण कार्यक्रम",
            image_hd: Images.hindi15_hd,
            image: Images.hindi15_ld,
        }, {
            title: "मधुमेह",
            image_hd: Images.hindi16_hd,
            image: Images.hindi16_ld,
        }, {
            title: "मानसिकता का विकास",
            image_hd: Images.hindi17_hd,
            image: Images.hindi17_ld,
        }, {
            title: "संघर्ष समाधान के लिए तकनीक",
            image_hd: Images.hindi18_hd,
            image: Images.hindi18_ld,
        }, {
            title: "सकारात्मक सोच",
            image_hd: Images.hindi19_hd,
            image: Images.hindi19_ld,
        }, {
            title: "तनाव का जवाब देना",
            image_hd: Images.hindi21_hd,
            image: Images.hindi21_ld,
        }, {
            title: "तनाव कम करने के लिए साँस लेने की तकनीक",
            image_hd: Images.hindi22_hd,
            image: Images.hindi22_ld,
        }, {
            title: "आपका अपना सर्वश्रेष्ठ स्व प्राप्त करें",
            image_hd: Images.hindi23_hd,
            image: Images.hindi23_ld,
        }, {
            title: "संघर्ष समाधान के कौशल",
            image_hd: Images.hindi25_hd,
            image: Images.hindi25_ld,
        }, {
            title: "मध् लक्षण",
            image_hd: Images.hindi26_hd,
            image: Images.hindi26_ld,
        }, {
            title: "लक्षण जानें",
            image_hd: Images.hindi27_hd,
            image: Images.hindi27_ld,
        }, {
            title: "फाइट या फ्लाइट क्या है?",
            image_hd: Images.hindi28_hd,
            image: Images.hindi28_ld,
        }, {
            title: "मानसिक स्वास्थ्य",
            image_hd: Images.hindi29_hd,
            image: Images.hindi29_ld,
        }, {
            title: "थेरेपी कैसे मदद करती है",
            image_hd: Images.hindi30_hd,
            image: Images.hindi30_ld,
        }, {
            title: "नींद प्रबंधन",
            image_hd: Images.hindi31_hd,
            image: Images.hindi31_ld,
        }, {
            title: "टीमों की भलाई में कैसे मदद करें",
            image_hd: Images.hindi32_hd,
            image: Images.hindi32_ld,
        }, {
            title: "एक समस्या साझा करने से समस्या आधी हो जाती है",
            image_hd: Images.hindi33_hd,
            image: Images.hindi33_ld,
        },
        {
            title: "सवाल पूछें, एक जीवन बचाएं",
            image_hd: Images.hindi34_hd,
            image: Images.hindi34_ld,
        },
        {
            title: "टूटा हुआ दिल",
            image_hd: Images.hindi35_hd,
            image: Images.hindi35_ld,
        },
        {
            title: "आम भ्रांति",
            image_hd: Images.hindi36_hd,
            image: Images.hindi36_ld,
        },
        {
            title: "ठेकेदार पासपोर्ट वॉलेट कार्ड प्रबंधन के लिए",
            image_hd: Images.hindi37_hd,
            image: Images.hindi37_ld,
        },
        {
            title: "ठेकेदार-पासपोर्ट पोस्टर उपयोगकर्ताओं के लिए",
            image_hd: Images.hindi38_hd,
            image: Images.hindi38_ld,
        },
        {
            title: "ठेकेदार-पासपोर्ट वॉलेट-कार्ड उपयोगकर्ताओं के लिए",
            image_hd: Images.hindi39_hd,
            image: Images.hindi39_ld,
        },
        {
            title: "स्वस्थ स्नैक्स",
            image_hd: Images.hindi40_hd,
            image: Images.hindi40_ld,
        },
        {
            title: "प्रबंधन ठेकेदार-पासपोर्ट पोस्टर",
            image_hd: Images.hindi41_hd,
            image: Images.hindi41_ld,
        },
        {
            title: "WHO-5 पोस्टर",
            image_hd: Images.hindi42_hd,
            image: Images.hindi42_ld,
        },
        {
            title: "QPR पोस्टर (QR कोड के साथ)",
            image_hd: Images.hindi43_hd,
            image: Images.hindi43_ld,
        },
        {
            title: "तनाव के संकेत अरामको पोस्टर",
            image_hd: Images.hindi44_hd,
            image: Images.hindi44_ld,
        },
        {
            title: "पानी की कमी से बचाव के लिए टिप्स",
            image_hd: Images.hindi45_hd,
            image: Images.hindi45_ld,
        },
        {
            title: "प्रेरणादायक कहावत 1",
            image_hd: Images.hindi46_hd,
            image: Images.hindi46_ld,
        },
        {
            title: "प्रेरणादायक कहावत 3",
            image_hd: Images.hindi47_hd,
            image: Images.hindi47_ld,
        },
        {
            title: "हमारी सेवा का उपयोग कब करें",
            image_hd: Images.hindi48_hd,
            image: Images.hindi48_ld,
        },
        {
            title: "WHO-5 स्टिकर",
            image_hd: Images.hindi49_hd,
            image: Images.hindi49_ld,
        },
        {
            title: "मानसिक स्वास्थ्य कौशल प्रबंधक",
            image_hd: Images.hindi50_hd,
            image: Images.hindi50_ld,
        },
        {
            title: "बर्नआउट कम करें",
            image_hd: Images.hindi51_hd,
            image: Images.hindi51_ld,
        },
        {
            title: "निर्जलीकरण की रोकथाम",
            image_hd: Images.hindi52_hd,
            image: Images.hindi52_ld,
        },
        {
            title: "समुदाय के मूल्यों का समर्थन",
            image_hd: Images.hindi53_hd,
            image: Images.hindi53_ld,
        },
        {
            title: "घबराहट के दौरे",
            image_hd: Images.hindi54_hd,
            image: Images.hindi54_ld,
        },
        {
            title: "कठि न बा तची त के लि ए एक प्रबंधन कौ शल-भा वना त्मक बुद्धि मत्ता",
            image_hd: Images.hindi55_hd,
            image: Images.hindi55_ld,
        },
        {
            title: "धिक् सोच-विचार",
            image_hd: Images.hindi56_hd,
            image: Images.hindi56_ld,
        },
        {
            title: "तनाव के लक्षणों की पहचान",
            image_hd: Images.hindi57_hd,
            image: Images.hindi57_ld,
        },
        {
            title: "आदतें बदलने के उपकरण",
            image_hd: Images.hindi58_hd,
            image: Images.hindi58_ld,
        },
        {
            title: "प्रवासी कल्याण",
            image_hd: Images.hindi59_hd,
            image: Images.hindi59_ld,
        },
        {
            title: "वित्तीय कल्याण",
            image_hd: Images.hindi60_hd,
            image: Images.hindi60_ld,
        },
        {
            title: "माइंडफुलनेस",
            image_hd: Images.hindi61_hd,
            image: Images.hindi61_ld,
        },
        {
            title: "गर्मी का तनाव",
            image_hd: Images.hindi62_hd,
            image: Images.hindi62_ld,
        },
        {
            title: "काम पर थका हुआ महसूस कर रहे हैं?",
            image_hd: Images.hindi63_hd,
            image: Images.hindi63_ld,
        },
        {
            title: "गर्मी में जीवित रहने की मार्गदर्शिका",
            image_hd: Images.hindi64_hd,
            image: Images.hindi64_ld,
        },
        {
            title: "दांतों की सफाई",
            image_hd: Images.hindi65_hd,
            image: Images.hindi65_ld,
        },
        {
            title: "परिवार के साथ ऑनलाइन संवाद",
            image_hd: Images.hindi66_hd,
            image: Images.hindi66_ld,
        },
        {
            title: "अपना आत्मविश्वास बढ़ाएं",
            image_hd: Images.hindi67_hd,
            image: Images.hindi67_ld,
        },
        {
            title: "ठेकेदार की भलाई",
            image_hd: Images.hindi68_hd,
            image: Images.hindi68_ld,
        },
        {
            title: "शारीरिक स्वास्थ्य में तनाव",
            image_hd: Images.hindi69_hd,
            image: Images.hindi69_ld,
        },

    ],
    tagalog: [
        {
            title: 'Kilalanin ang mga Babalang Palatandaan',
            image_hd: Images.tagalog1_hd,
            image: Images.tagalog1_ld,
        }, {
            title: 'Pamamahala ng stress',
            image_hd: Images.tagalog2_hd,
            image: Images.tagalog2_ld,
        }, {
            title: 'Pamamahala ng kalungkutan',
            image_hd: Images.tagalog3_hd,
            image: Images.tagalog3_ld,
        }, {
            title: 'HINDI KA NAGIISA',
            image_hd: Images.tagalog4_hd,
            image: Images.tagalog4_ld,
        }, {
            title: 'HINDI KA NAGIISA',
            image_hd: Images.tagalog5_hd,
            image: Images.tagalog5_ld,
        }, {
            title: 'Malungkot?',
            image_hd: Images.tagalog6_hd,
            image: Images.tagalog6_ld,
        }, {
            title: 'Programang Kagalingan ng mga Manggagawa',
            image_hd: Images.tagalog7_hd,
            image: Images.tagalog7_ld,
        }, {
            title: 'Okay lang humingi ng tulong',
            image_hd: Images.tagalog8_hd,
            image: Images.tagalog8_ld,
        }, {
            title: "Ano ang maaaring maging sanhi ng kakulangan sa tulog?",
            image_hd: Images.tagalog10_hd,
            image: Images.tagalog10_ld,
        }, {
            title: "Maaaring humantong ang kakulangan sa suportang panlipunan",
            image_hd: Images.tagalog11_hd,
            image: Images.tagalog11_ld,
        }, {
            title: "Huwag mong ipaglaban ang iyong laban nang mag-isa",
            image_hd: Images.tagalog12_hd,
            image: Images.tagalog12_ld,
        }, {
            title: "Ang mga benepisyo ng kagalingan",
            image_hd: Images.tagalog13_hd,
            image: Images.tagalog13_ld,
        }, {
            title: "APAT NA URI NG SINTOMAS NG PTSD",
            image_hd: Images.tagalog14_hd,
            image: Images.tagalog14_ld,
        }, {
            title: "Programa para sa Kapakanan ng mga Kontraktor",
            image_hd: Images.tagalog15_hd,
            image: Images.tagalog15_ld,
        }, {
            title: "Diabetes",
            image_hd: Images.tagalog16_hd,
            image: Images.tagalog16_ld,
        }, {
            title: "Malagong kaisipan",
            image_hd: Images.tagalog17_hd,
            image: Images.tagalog17_ld,
        }, {
            title: "Mga pamamaraan sa paglutas ng salungatan",
            image_hd: Images.tagalog18_hd,
            image: Images.tagalog18_ld,
        }, {
            title: "Positibong pag-iisip",
            image_hd: Images.tagalog19_hd,
            image: Images.tagalog19_ld,
        }, {
            title: "Pagtugon sa stress",
            image_hd: Images.tagalog21_hd,
            image: Images.tagalog21_ld,
        }, {
            title: "Ano ang 'Labon o Takbo'?",
            image_hd: Images.tagalog22_hd,
            image: Images.tagalog22_ld,
        }, {
            title: "Paano makakatulong ang therapy o gamutan",
            image_hd: Images.tagalog23_hd,
            image: Images.tagalog23_ld,
        }, {
            title: "MGA KASANAYAN SA PAGLUTAS NG SALUNGATAN",
            image_hd: Images.tagalog24_hd,
            image: Images.tagalog24_ld,
        }, {
            title: "PAMAMAHALA NG PAGTULOG",
            image_hd: Images.tagalog25_hd,
            image: Images.tagalog25_ld,
        }, {
            title: "MGA TIP PARA SA PAGPAPANATILI NG KALUSUGAN NG ISIP",
            image_hd: Images.tagalog26_hd,
            image: Images.tagalog26_ld,
        }, {
            title: "Paghinga gamit ang tiyan",
            image_hd: Images.tagalog27_hd,
            image: Images.tagalog27_ld,
        }, {
            title: "Panawagan sa Aksyon",
            image_hd: Images.tagalog28_hd,
            image: Images.tagalog28_ld,
        }, {
            title: "Karamdaman",
            image_hd: Images.tagalog29_hd,
            image: Images.tagalog29_ld,
        }, {
            title: "Kilalanin ang mga Sintomas",
            image_hd: Images.tagalog30_hd,
            image: Images.tagalog30_ld,
        }, {
            title: "Ang isang problema na ibinabahagi ay problema na kalahati na",
            image_hd: Images.tagalog31_hd,
            image: Images.tagalog31_ld,
        },
        {
            title: "Magtanong ka, magligtas ng buhay",
            image_hd: Images.tagalog32_hd,
            image: Images.tagalog32_ld,
        },
        {
            title: "Wasak na puso",
            image_hd: Images.tagalog33_hd,
            image: Images.tagalog33_ld,
        },
        {
            title: "Karaniwang maling pag-unawa",
            image_hd: Images.tagalog34_hd,
            image: Images.tagalog34_ld,
        },
        {
            title: "Contractor Passport Wallet Card para sa Pamamahala",
            image_hd: Images.tagalog35_hd,
            image: Images.tagalog35_ld,
        },
        {
            title: "Contractor-Passport Poster para sa mga Gumagamit",
            image_hd: Images.tagalog36_hd,
            image: Images.tagalog36_ld,
        },
        {
            title: "Contractor-Passport Wallet-Card para sa mga Gumagamit",
            image_hd: Images.tagalog37_hd,
            image: Images.tagalog37_ld,
        },
        {
            title: "Malusog na Meryenda",
            image_hd: Images.tagalog38_hd,
            image: Images.tagalog38_ld,
        },
        {
            title: "Pamamahala Contractor-Passport Poster",
            image_hd: Images.tagalog39_hd,
            image: Images.tagalog39_ld,
        },
        {
            title: "Poster para sa WHO-5",
            image_hd: Images.tagalog40_hd,
            image: Images.tagalog40_ld,
        },
        {
            title: "QPR Poster (na may QR Codes)",
            image_hd: Images.tagalog41_hd,
            image: Images.tagalog41_ld,
        },
        {
            title: "Mga Palatandaan ng Stress Aramco Poster",
            image_hd: Images.tagalog42_hd,
            image: Images.tagalog42_ld,
        },
        {
            title: "Mga Tip upang Maiwasan ang Pagka-dehydrate",
            image_hd: Images.tagalog43_hd,
            image: Images.tagalog43_ld,
        },
        {
            title: "Nakakaangat na Kasabihan 1",
            image_hd: Images.tagalog44_hd,
            image: Images.tagalog44_ld,
        },
        {
            title: "Nakakaangat na Kasabihan 3",
            image_hd: Images.tagalog45_hd,
            image: Images.tagalog45_ld,
        },
        {
            title: "Kailan Gamitin ang Aming Serbisyo",
            image_hd: Images.tagalog46_hd,
            image: Images.tagalog46_ld,
        },
        {
            title: "WHO-5 Sticker",
            image_hd: Images.tagalog47_hd,
            image: Images.tagalog47_ld,
        }, {
            title: "Paano Tumulong sa Kapakanan ng mga Koponan",
            image_hd: Images.tagalog48_hd,
            image: Images.tagalog48_ld,
        }, {
            title: "Bawasan ang Pagkapagod",
            image_hd: Images.tagalog49_hd,
            image: Images.tagalog49_ld,
        },
        {
            title: "Tagapamahala ng Kasanayan sa Kalusugan ng Isipan",
            image_hd: Images.tagalog50_hd,
            image: Images.tagalog50_ld,
        },
        {
            title: "Pag-iwas sa Pagkawala ng Tubig sa Katawan",
            image_hd: Images.tagalog51_hd,
            image: Images.tagalog51_ld,
        },
        {
            title: "Suporta sa Halaga ng Komunidad",
            image_hd: Images.tagalog52_hd,
            image: Images.tagalog52_ld,
        },
        {
            title: "Mga Atake ng Panic",
            image_hd: Images.tagalog53_hd,
            image: Images.tagalog53_ld,
        },
        {
            title: "Isang Kakayahang Pangpamamahala para sa Mahihirap na Usapan-Emosyonal na Intelihensiya",
            image_hd: Images.tagalog54_hd,
            image: Images.tagalog54_ld,
        },
        {
            title: "SOBRANG PAG-IISIP",
            image_hd: Images.tagalog55_hd,
            image: Images.tagalog55_ld,
        },
        {
            title: "Pagkilala sa mga palatandaan ng stress",
            image_hd: Images.tagalog56_hd,
            image: Images.tagalog56_ld,
        },
        {
            title: "PAG-UNAWA SA MGA GAWI",
            image_hd: Images.tagalog57_hd,
            image: Images.tagalog57_ld,
        },
        {
            title: "KALUSUGANG PINANSYAL",
            image_hd: Images.tagalog58_hd,
            image: Images.tagalog58_ld,
        },
        {
            title: "KALUSUGAN NG MGA EXPAT",
            image_hd: Images.tagalog59_hd,
            image: Images.tagalog59_ld,
        },
        {
            title: "Pagiging Maalalahanin",
            image_hd: Images.tagalog60_hd,
            image: Images.tagalog60_ld,
        },
        {
            title: "Pagkapagod sa Init",
            image_hd: Images.tagalog61_hd,
            image: Images.tagalog61_ld,
        },
        {
            title: "Pakiramdam na Ubos sa Trabaho?",
            image_hd: Images.tagalog62_hd,
            image: Images.tagalog62_ld,
        },
        {
            title: "Gabay sa Pagtagumpay sa Tag-init",
            image_hd: Images.tagalog63_hd,
            image: Images.tagalog63_ld,
        },
        {
            title: "Kalinisang Pangngipin",
            image_hd: Images.tagalog64_hd,
            image: Images.tagalog64_ld,
        },
        {
            title: "Pakikipag-ugnayan sa Pamilya Online",
            image_hd: Images.tagalog65_hd,
            image: Images.tagalog65_ld,
        },
        {
            title: "Palakasin ang Iyong Kumpiyansa sa Sarili",
            image_hd: Images.tagalog66_hd,
            image: Images.tagalog66_ld,
        },
        {
            title: "Kapakanan ng Kontraktor",
            image_hd: Images.tagalog67_hd,
            image: Images.tagalog67_ld,
        },
        {
            title: "Stress sa Kalusugan ng Katawan",
            image_hd: Images.tagalog68_hd,
            image: Images.tagalog68_ld,
        },

    ],
    nepali: [],
}

export const YTlinks = {
    english: [{
        title: 'What is Mental Health?',
        embedId: 'G0zJGDokyWQ'
    },
    {
        title: 'Mental Health Awareness | Comic Relief',
        embedId: 'tv82K_M7o5A'
    },
    {
        title: 'Mental Health Wellness Tips',
        embedId: 'NQcYZplTXnQ'
    },
    {
        title: 'The Five Ways to Wellbeing - boosting mental wellbeing',
        embedId: '_gJ5V525SCk'
    }, {
        title: 'Calm your anxiety in 2 minutes!',
        embedId: '5zhnLG3GW-8'
    },
    {
        title: 'Contractor Wellbeing',
        embedId: 'cdkPES5wCnc'
    },
    {
        title: '5 Mins Guided Meditation',
        embedId: 'fCoXVZ9nJ1c'
    },
    {
        title: 'Six Patterns of Negative Thinking',
        embedId: '3Es-3SDVKlk'
    },
    {
        title: 'How to Help Someone Who’s Suicidal',
        embedId: 'Ad_OFUUSaxM'
    },
    {
        "title": "Meditation Technique – Manifestation",
        "embedId": "6sSPc9R_7y0"
    },
    {
        "title": "Dealing with miscommunications in relationships",
        "embedId": "cUxbXuPvQqw"
    },
    {
        "title": "Onsite Events Presentation - Stress Management Presentation",
        "embedId": "XcVgLgUCURY"
    }
    ],
    arabic: [{
        title: 'فيديو الصحة النفسية',
        embedId: 'LI1SviVx-Uc'
    },
    {
        title: 'أسباب المرض النفسي',
        embedId: '1x0ZRj80fho'
    }, {
        title: 'ما هي الصحة العقلية؟',
        embedId: '0dXePCXyKZ0'
    }, {
        title: 'كيف تهدئ نفسك عندما تكون متوترا؟',
        embedId: 'FdwuzBTIMHg'
    }, {
        title: 'برنامج رفاهية المقاولين',
        embedId: "73tNwPIQXlI"
    }, {
        title: 'طريقة التنفس البطني لتخفيف التوتر',
        embedId: "krnIbj7EKG8"
    }, {
        title: 'عشر نصائح للوقاية من الأمراض النفسية والعقلية',
        embedId: "1NQYVls4h0g"
    }, {
        title: 'عشرة أخطاء تفكير تسبب القلق والاكتئاب وغيرها من الأمراض النفسية',
        embedId: "VLBj-_hv-uo"
    }, {
        title: 'تمرين استرخاء العضلات',
        embedId: "nMfN5qvhnX8"
    }, {
        title: 'إدارة التوتر',
        embedId: 'SrnNaivnG3o'
    },
    ],
    urdu: [{
        title: 'بے چینی کے لیے سانس لینے کی مشقیں۔',
        embedId: '8MmlWhpBxzE'
    }, {
        title: 'تناؤ کے لیے گراؤنڈنگ تکنیک',
        embedId: '5OmN3QlYX5I'
    }, {
        title: 'تنہائی کا مقابلہ کرنا',
        embedId: 'AglJ8GsVFsI'
    }, {
        title: 'قابو کا احساس',
        embedId: 'v3Q2KD0RUjM'
    }, {
        title: 'تناؤ اور پریشانی پر قابو پانے کے طریقے',
        embedId: 'b4Laf4NdNwc'
    }, {
        title: 'مثبتیت',
        embedId: 'FRLdVQ3HZy4'
    }, {
        title: 'کے ذریعے مقابلہ کرنا CBT',
        embedId: 'GtsAUqRoT2A'
    }, {
        title: 'دماغی صحت کیا ہے؟',
        embedId: 'Mx7o-r_XJ_w'
    }, {
        title: 'ٹھیکیدار کی فلاح و بہبود کا پروگرام',
        embedId: '1y8SBdkVCn0'
    },
    {
        title: 'تناؤ کا نظم',
        embedId: 'dPFBogWfvmo'
    },

    ],
    hindi: [{
        title: 'बेहतर सांस लेने से चिंता से निपटना',
        embedId: 'AiseyJEXqgI'
    }, {
        title: 'तनाव और चिंता को नियंत्रित करने के 5 तरीके',
        embedId: 'b4Laf4NdNwc'
    }, {
        title: 'अकेलेपन से मुकाबला',
        embedId: 'AglJ8GsVFsI'
    }, {
        title: 'मानसिक स्वास्थ्य का पोषण',
        embedId: 'ViXrlwACKws'
    }, {
        title: 'चिंता से मुकाबला',
        embedId: '6-NoRgvjsw4'
    }, {
        title: 'चिंता से निपटना - विभिन्न तरीके',
        embedId: 'bLpBxtmqMSM'
    }, {
        title: 'हम नियंत्रण खोने का अनुभव क्यों करते हैं',
        embedId: 'kPvXpFmIE-I'
    }, {
        title: 'ठेकेदार कल्याण कार्यक्रम',
        embedId: 'qCGOJcrAj_A'
    },
    {
        title: 'तनाव प्रबंधन',
        embedId: '0th4jWHdgFw'
    },
    {
        title: 'काउंसलिंग क्या है और इसे कौन ले सकता है? (किस तरह की समस्याओं के लिए)',
        embedId: 'e1gDmC-OrdY'
    },
    {
        title: 'मुझे गुस्सा क्यों आता है और इसे कैसे नियंत्रित करें?',
        embedId: '6cZ3IpFY9d8'
    },

    ],
    tagalog: [{
        title: 'ANG IYONG Kalusugang Pangkaisipan AY KASING MAHALAGA NG IYONG PISIKAL NA KALUSUGAN!',
        embedId: 'SXoRKcg8KP0'
    },
    {
        title: 'Kalusugang pangkaisipan',
        embedId: 'xEb8KVAwy3M'
    },
    {
        title: 'Pagkabalisa at pag-atake ng sindak: Sintomas at Lunas | Ninenerbiyos? Takot?',
        embedId: '_aVWfDDpN5k'
    },
    {
        title: 'Pagkakaiba ng paconsulta sa psychiatrist or psychologist?',
        embedId: 'DuAZFuFQNGg'
    },
    {
        title: 'Bakit maraming Pinoy ang hirap humingi ng tulong para sa mental health?',
        embedId: 'Obx0mOYSOVQ'
    }, {
        title: 'Ano ang kalusugang pangkaisipan?',
        embedId: 'cSMLdWhhINI'
    }, {
        title: 'Programa sa Kagalingan ng Kontratista',
        embedId: '9RdHyUFJ_uo'
    }, {
        title: 'PAANO KUMALMA? 🧘🏻‍♂️ Iwas STRESS, KABA, ANXIETY o NERBIYOS',
        embedId: '7Gq437m0l6A'
    },
    {
        title: 'Pamamahala ng stress',
        embedId: 'QiLW4_jfq2w'
    },

    ],
    chinese: [{
        title: '关于抑郁症的事实',
        link: 'https://www.who.int/zh/news-room/fact-sheets/detail/depression',
        dImg: Images.url_image_1,
    }, {
        title: 'Covid-19 和心理健康影响',
        link: 'https://www.bsu.edu.cn/kjxgfyyqzt/fwxx/99e5742acc09445db88b6cd35b194831.htm',
        dImg: Images.url_image_2,
    }, {
        title: 'What is Mental Health? (Mandarin - 普通话) #1',
        embedId: 'IuprEXbpgmg'
    }, {
        title: '技巧：如何应对焦虑',
        link: 'http://health.people.com.cn/n1/2016/0327/c14739-28229178.html',
        dImg: Images.url_image_3,
    }, {
        title: '如何让压力成为你的朋友：第 1 部分',
        embedId: '_L_4c9V6md4'
    }, {
        title: '如何让压力成为你的朋友：第 2 部分',
        embedId: '8yapyhTBGYc'
    }, {
        title: '承包商福利计划',
        embedId: 'UiIeiIDYH6g'
    }, {
        title: '深呼吸练习 (普通話)',
        embedId: '4pcGFL48Hgw'
    }, {
        title: 'Anger Management | Mandarin | 愤怒管理',
        embedId: '4KFtNi4s-eg'
    }, {
        title: 'Building Resilience | Mandarin | 培养心理抗逆力',
        embedId: 'blyE8tTPowc'
    }, {
        title: 'Mental Health & Mindfulness | Mandarin | 健康的生活习惯',
        embedId: 'KyrAbYH0qBc'
    },
    {
        title: '压力管理',
        embedId: '-ReyWwjFm3Y'
    },

    ],
    bangali: [{
        title: 'যখন দুঃখ খুব বেশি হয়: মানসিক স্বাস্থ্য নিয়ে একটি বাংলা চলচ্চিত্র',
        embedId: 'RLBOoTKMHXk'
    },
    {
        title: 'মানসিক স্বাস্থ্য সম্পর্কে সাধারণ উদ্বেগ',
        embedId: 'zoX6XzVSw9A'
    },
    {
        title: 'মানসিক স্বাস্থ্য নিয়ে ভেবেছেন কখনো?',
        embedId: 'f-ZLP5g2pJI'
    },
    {
        title: 'আপনি কিভাবে আপনার রাগ নিয়ন্ত্রণ করবেন?',
        embedId: 'LeOcJdgoPXs'
    },
    {
        title: 'আন্তঃপারস্পরিক দ্বন্দ্ব',
        embedId: '012B3fg4toQ'
    },
    {
        title: 'স্বাস্থ্য উদ্বেগ',
        embedId: '_op_smhrzs8'
    },
    {
        title: 'কিভাবে রিলাক্সেশন অনুশীলন করবেন? বৈজ্ঞানিক ব্যাখ্যা',
        embedId: 'WzkFqUbpen0'
    }, {
        title: 'ঠিকাদার ওয়েলবিং প্রোগ্রাম',
        embedId: 'wiQNxNj5ljo'
    },
    {
        title: 'স্ট্রেস ম্যানেজমেন্ট',
        embedId: '-CtB546CUqc'
    },
    ],
    nepali: [{
        title: 'नेपाली सन्देश – ठेकेदार कल्याण कार्यक्रम',
        embedId: 'ATu3cjPN7kM'
    },
    {
        title: 'नेपाली दाजुभाइहरूका लागि छोटो सन्देश',
        embedId: 'lAzxlxWzYY0'
    },
    {
        title: 'ठेकेदार कल्याण कार्यक्रम',
        embedId: 'Jy7ZveoLfPg'
    },
    {
        title: 'नेपाली कल्याण सन्देश',
        embedId: '9K9B8o7_6dU'
    },
    ]
}

export const Constants = {
    english: {
        heading: 'Welcome to our Wellness Center!',
        subHeading: 'Our goal is to help you improve your health and happiness.',
        hotline_btn: '24/7 Hotline',
        vid_call_btn: 'Video Call Therapist',
        whatsApp_btn: 'Get Help from WhatsApp',
        choose_lang: 'Choose Your Language',
        choose_cat: 'Choose Category',
        contact_us: 'Contact us on 8008500619',
        okay: 'OK',
        web_portal: "Use Browser",
        iOS_portal: "Download iOS App",
        android_portal: "Download Android App",
        select_category: "Select Category",
        videos_txt: "Videos",
        blogs_txt: "Handouts / Posters",
        none_txt: "None",
        toolbox_talks: "ToolBox Talks",
        Who_btn: 'WH05',
        resources_btn: 'Resources',
        privacy_btn: 'Privacy & Data Disclosure',
        privacy_url: 'https://www.saayahealth.com/english-privacy-notice',
        no_data_msg: "No content available for this category yet.",
    },

    urdu: {
        heading: 'ہمارے فلاح و بہبود کے مرکز میں خوش آمدید',
        subHeading: 'ہمارا مقصد آپ کی صحت اور خوشی کو بہتر بنانے میں مدد کرنا ہے۔',
        hotline_btn: '24/7 ہاٹ لائن',
        vid_call_btn: 'ویڈیو کال تھراپسٹ',
        whatsApp_btn: 'واٹس ایپ سے مدد حاصل کریں',
        choose_lang: 'اپنی زبان کا انتخاب کریں',
        choose_cat: 'قسم کا انتخاب کریں',
        contact_us: 'ہم سے 8008500619 پر رابطہ کریں',
        okay: 'ٹھیک ہے',
        web_portal: "براؤزر استعمال کریں۔",
        iOS_portal: " ایپ ڈاؤن لوڈ کریں۔ iOS",
        android_portal: "اینڈرائیڈ ایپ ڈاؤن لوڈ کریں۔",
        select_category: "قسم منتخب کریں۔",
        videos_txt: "ویڈیوز",
        blogs_txt: "ہینڈ آؤٹ/پوسٹر",
        none_txt: "کوئی نہیں",
        toolbox_talks: "ToolBox Talks",
        Who_btn: 'WH05',
        resources_btn: 'وسائل',
        privacy_btn: 'رازداری اور ڈیٹا کا افشا',
        privacy_url: 'https://www.saayahealth.com/urdu-privacy-notice',
    },


    arabic: {
        heading: '!مرحبًا بكم في مركزالعافية',
        subHeading: '.هدفنا مساعدتك في تحسين صحتك وسعادتك',
        hotline_btn: '24/7 الخط المباشر',
        vid_call_btn: 'جلسة فيديو مع أخصائي',
        whatsApp_btn: `أحصل على المساعدة من خلال
        whatsapp
        `,
        choose_lang: 'اختر لغتك',
        choose_cat: 'اختر الكاتيرجوري',
        contact_us: 'تواصل معنا على 8008500619',
        okay: 'موافق',
        web_portal: "استخدم المستعرض",
        iOS_portal: "قم بتنزيل تطبيق iOS",
        android_portal: "قم بتنزيل تطبيق Android",
        select_category: "حدد النوع",
        videos_txt: "أشرطة فيديو",
        blogs_txt: "النشرات / الملصقات",
        none_txt: "لا أحد",
        toolbox_talks: "ToolBox Talks",
        Who_btn: 'WH05',
        resources_btn: 'موارد',
        privacy_btn: 'الخصوصية والإفصاح عن البيانات',
        privacy_url: 'https://www.saayahealth.com/arabic-privacy-notice',
    },


    chinese: {
        heading: '欢迎来到我们的健康中心！',
        subHeading: '我们的目标是帮助您改善健康和幸福。',
        hotline_btn: '24/7 热线',
        vid_call_btn: '视频通话治疗师',
        whatsApp_btn: '从 WhatsApp 获得帮助',
        choose_lang: '选择你的语言',
        choose_cat: '選擇類別',
        contact_us: '联系我们 8008500619',
        okay: '行',
        web_portal: "使用浏览器",
        iOS_portal: "下载 iOS 应用程序",
        android_portal: "下载安卓应用",
        select_category: "選擇類型。",
        videos_txt: "視頻",
        blogs_txt: "講義/海報",
        none_txt: "沒有任何",
        toolbox_talks: "ToolBox Talks",
        Who_btn: 'WH05',
        resources_btn: '资源',
        privacy_btn: '隐私和数据披露',
        privacy_url: 'https://www.saayahealth.com/chinese-privacy-notice',
    },

    bangali: {
        heading: 'আমাদের সুস্থতা কেন্দ্রে স্বাগতম!',
        subHeading: 'আমাদের লক্ষ্য আপনাকে আপনার স্বাস্থ্য এবং সুখ উন্নত করতে সাহায্য করা।',
        hotline_btn: '24/7 হটলাইন',
        vid_call_btn: 'ভিডিও কল থেরাপিস্ট',
        whatsApp_btn: 'হোয়াটসঅ্যাপ থেকে সাহায্য নিন',
        choose_lang: 'আপনার ভাষা নির্বাচন করুন',
        choose_cat: 'বিভাগ নির্বাচন করুন',
        contact_us: '8008500619 এ আমাদের সাথে যোগাযোগ করুন',
        okay: 'ঠিক আছে',
        web_portal: "ব্রাউজার ব্যবহার করুন",
        iOS_portal: "आईओएस ऐप डाउनलोड करें",
        android_portal: "অ্যান্ড্রয়েড অ্যাপ ডাউনলোড করুন",
        select_category: "প্রকার নির্বাচন করুন।",
        videos_txt: "ভিডিও",
        blogs_txt: "হ্যান্ডআউট / পোস্টার",
        none_txt: "কোনোটিই নয়",
        toolbox_talks: "ToolBox Talks",
        Who_btn: 'WH05',
        resources_btn: 'সম্পদ',
        privacy_btn: 'গোপনীয়তা ও ডেটা প্রকাশ',
        privacy_url: 'https://www.saayahealth.com/bangla-privacy-notice',
    },


    hindi: {
        heading: 'हमारे वेलनेस सेंटर में आपका स्वागत है!',
        subHeading: 'हमारा लक्ष्य आपके स्वास्थ्य और खुशी को बेहतर बनाने में आपकी मदद करना है।',
        hotline_btn: '24/7 हॉटलाइन',
        vid_call_btn: 'वीडियो कॉल थेरेपिस्ट',
        whatsApp_btn: 'व्हाट्सएप से मदद लें',
        choose_lang: 'अपनी भाषा चुनिए',
        choose_cat: 'कैटरगरी चुनें',
        contact_us: 'हमसे 8008500619 पर संपर्क करें',
        okay: 'ठीक है',
        web_portal: "ब्राउज़र का प्रयोग करें",
        iOS_portal: "iOS অ্যাপ ডাউনলোড করুন",
        android_portal: "एंड्रॉइड ऐप डाउनलोड करें",
        select_category: "प्रकार का चयन करें।",
        videos_txt: "वीडियो",
        blogs_txt: "हैंडआउट्स / पोस्टर",
        none_txt: "कोई भी नहीं",
        toolbox_talks: "ToolBox Talks",
        Who_btn: 'WH05',
        resources_btn: 'संसाधन',
        privacy_btn: 'गोपनीयता और डेटा प्रकटीकरण',
        privacy_url: 'https://www.saayahealth.com/hindi-privacy-notice',
    },



    tagalog: {
        heading: 'Maligayang pagdating sa aming Wellness Center!',
        subHeading: 'Ang aming layunin ay tulungan kang mapabuti ang iyong kalusugan at kaligayahan.',
        hotline_btn: '24/7 Hotline',
        vid_call_btn: 'Video Call Therapist',
        whatsApp_btn: 'Kumuha ng Tulong mula sa WhatsApp',
        choose_lang: 'Piliin ang Iyong Wika',
        choose_cat: 'Piliin ang Kategorya',
        contact_us: 'Makipag-ugnayan sa amin sa 8008500619',
        okay: 'OK',
        web_portal: "Gumamit ng Browser",
        iOS_portal: "I-download ang iOS App",
        android_portal: "I-download ang Android App",
        select_category: "Piliin ang uri",
        videos_txt: "Mga video",
        blogs_txt: "Mga handout / Poster",
        none_txt: "wala",
        toolbox_talks: "ToolBox Talks",
        Who_btn: 'WH05',
        resources_btn: 'mapagkukunan',
        privacy_btn: 'Privacy at Pagsisiwalat ng Data',
        privacy_url: 'https://www.saayahealth.com/tagalog-privacy-notice',
        no_data_msg: "Walang available na nilalaman para sa kategoryang ito.",
    },

    nepali: {
        heading: 'हाम्रो वेलनेस सेन्टरमा स्वागत छ!',
        subHeading: 'हाम्रो लक्ष्य तपाईंलाई आफ्नो स्वास्थ्य र खुशी सुधार गर्न मद्दत गर्नु हो।',
        hotline_btn: '24/7 हटलाइन',
        vid_call_btn: 'भिडियो कल थेरापिस्ट',
        whatsApp_btn: 'WhatsApp बाट मद्दत लिनुहोस्',
        choose_lang: 'आफ्नो भाषा छान्नुहोस्',
        choose_cat: 'श्रेणी छान्नुहोस्',
        contact_us: '8008500619 मा हामीलाई सम्पर्क गर्नुहोस्',
        okay: 'ठिक छ',
        web_portal: "ब्राउजर प्रयोग गर्नुहोस्",
        iOS_portal: "iOS एप डाउनलोड गर्नुहोस्",
        android_portal: "एन्ड्रोइड एप डाउनलोड गर्नुहोस्",
        select_category: "प्रकार छान्नुहोस्",
        videos_txt: "भिडियोहरू",
        blogs_txt: "ह्यान्डआउट / पोस्टर",
        none_txt: "कुनै पनि होइन",
        toolbox_talks: "ToolBox Talks",
        Who_btn: 'WH05',
        resources_btn: 'स्रोतहरू',
        privacy_btn: 'गोपनीयता र डेटा खुलासा',
        privacy_url: 'https://www.saayahealth.com/english-privacy-notice',
        no_data_msg: "यस श्रेणीको लागि कुनै सामग्री उपलब्ध छैन।",
    }
}
export const testimonials = {
    english: [
        {
            text: "I am new to Saudi Arabia; I was scared. Now I feel safe that this service exists",
            user: "–User from India",
        },
        {
            text: "Thank you for caring. I have been here for 17 years, I have not seen anything like this",
            user: "–User from Bangladesh",
        },
        {
            text: "I learned how to control my anger. I can sleep better. Thank you",
            user: "–User from Saudi Arabia",
        }
    ],
    urdu: [
        {
            text: "میں سعودی عرب میں نیا ہوں؛ میں ڈر گیا. اب میں محفوظ محسوس کر رہا ہوں کہ یہ سروس موجود ہے",
            user: "-ہندوستان سے صارف",
        },
        {
            text: "دیکھ بھال کرنے کا شکریہ۔ میں یہاں 17 سال سے ہوں، میں نے ایسا کچھ نہیں دیکھا۔",
            user: "-بنگلہ دیش سے صارف",
        },
        {
            text: "میں نے اپنے غصے پر قابو پانے کا طریقہ سیکھا۔ میں بہتر سو سکتا ہوں۔ شکریہ",
            user: "سعودی عرب سے صارف",
        },
    ],
    arabic: [
        {
            text: "أنا جديد في السعودية؛ كنت خائفاً لكني الآن أشعر بالأمان بوجود هذه الخدمة",
            user: "-مستخدم من الهند",
        },
        {
            text: "شكراً على اهتمامكم. أنا هنا منذ 17 سنة ولم أرَ خدمة مثل هذه من قبل",
            user: "-مستخدم من بنجلاديش",
        },
        {
            text: "تعلمت كيف أتحكم في غضبي وأستطيع النوم بشكل أفضل. شكراً لكم",
            user: "-مستخدم من المملكة العربية السعودية",
        }
    ],
    chinese: [
        {
            text: "我刚到沙特阿拉伯，我很害怕。现在有了这项服务，我感到很安全",
            user: "-来自印度的用户",
        },
        {
            text: "谢谢你的关心。我在这里已经 17 年了，从未见过这样的事情",
            user: "-来自孟加拉国的用户",
        },
        {
            text: "我学会了如何控制自己的愤怒。我可以睡得更好了。谢谢",
            user: "-来自沙特阿拉伯的用户",
        }
    ],
    bengali: [
        {
            text: "“আমি সৌদি আরবে নতুন; আমি ভয় পেয়েছিলাম। এখন আমি নিরাপদ বোধ করছি যে এই পরিষেবাটি বিদ্যমান",
            user: "-ভারত থেকে ব্যবহারকারী",
        },
        {
            text: "যত্ন করার জন্য আপনাকে ধন্যবাদ. আমি এখানে 17 বছর ধরে আছি, আমি এরকম কিছু দেখিনি",
            user: "-বাংলাদেশ থেকে ব্যবহারকারী",
        },
        {
            text: "আমি আমার রাগকে নিয়ন্ত্রণ করতে শিখেছি। আমি ভালো ঘুমাতে পারি। ধন্যবাদ",
            user: "-সৌদি আরব থেকে ব্যবহারকারী",
        },
    ],
    hindi: [
        {
            text: "मैं सऊदी अरब में नया हूँ; मैं डरा हुआ था। अब मुझे सुरक्षित महसूस होता है कि यह सेवा मौजूद है",
            user: "-भारत से उपयोगकर्ता",
        },
        {
            text: "देखभाल के लिए धन्यवाद। मैं यहाँ 17 साल से हूँ, मैंने ऐसा कुछ नहीं देखा",
            user: "-बांग्लादेश से उपयोगकर्ता",
        },
        {
            text: "मैंने अपने गुस्से को नियंत्रित करना सीख लिया है। मैं बेहतर नींद ले सकता हूँ। धन्यवाद",
            user: "-सऊदी अरब से उपयोगकर्ता",
        }
    ],
    tagalog: [
        {
            text: "Bago ako sa Saudi Arabia; natakot ako. Ngayon ay nararamdaman kong ligtas na ang serbisyong ito ay umiiral",
            user: "-User mula sa India",
        },
        {
            text: "Salamat sa pag-aalaga. 17 years na ako dito, wala pa akong nakikitang ganito",
            user: "-User mula sa Bangladesh",
        },
        {
            text: "Natuto akong kontrolin ang galit ko. Mas makakatulog ako. salamat",
            user: "-User mula sa Saudi Arabia",
        }
    ],
    nepali: [
        {
            text: "म साउदी अरब आएको नयाँ हुँ; म डराएको थिएँ। अब यो सेवा भएकोले म सुरक्षित महसुस गर्छु",
            user: "-भारतका प्रयोगकर्ता",
        },
        {
            text: "ख्याल गरेकोमा धन्यवाद। म यहाँ १७ वर्षदेखि छु, मैले यस्तो कहिल्यै देखेको थिइनँ",
            user: "-बंगलादेशका प्रयोगकर्ता",
        },
        {
            text: "मैले मेरो रिस नियन्त्रण गर्न सिकेँ। अब म राम्रोसँग सुत्न सक्छु। धन्यवाद",
            user: "-साउदी अरबका प्रयोगकर्ता",
        }
    ]
};

